import * as Types from './types';

import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];

 const AddEquipmentCharge_MutationDocument = gql`
    mutation addEquipmentCharge_mutation($filter: ApiFilterOneCarrierInput!, $rate: RateEquipmentChargeInput!) {
  addEquipmentCharge(filter: $filter, rate: $rate) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const AddRateLaneBased_MutationDocument = gql`
    mutation addRateLaneBased_mutation($filter: ApiFilterOneCarrierInput!, $rate: ApiRateLaneBasedInput!) {
  addRateLaneBased(filter: $filter, rate: $rate) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const CreateCarrier_MutationDocument = gql`
    mutation createCarrier_mutation($carrierInput: ApiCreateCarrierInput!) {
  createCarrier(carrierInput: $carrierInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const CreateDispatcher_MutationDocument = gql`
    mutation createDispatcher_mutation($filter: ApiFilterOneCarrierInput!, $dispatcherInput: ApiDispatcherInput!) {
  createDispatcher(filter: $filter, dispatcherInput: $dispatcherInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const CreateFleet_MutationDocument = gql`
    mutation createFleet_mutation($fleetInput: CreateFleetInput!) {
  createFleet(fleetInput: $fleetInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    name
    bodyType
    fleetDimensions {
      totalLoadingWeight
      totalLoadingHeight
      totalLoadingWidth
      totalLoadingLength
      fleetCapabilities
    }
    carriers {
      id
      name
    }
    possibleLocationIds
    possibleCountries
    externalReference
  }
}
    `;
 const CreateVehicle_MutationDocument = gql`
    mutation createVehicle_mutation($vehicleInput: CreateVehicleInput!) {
  createVehicle(vehicleInput: $vehicleInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    name
    ldmm
    vehicleType
    maxLoadingWeight
    vehicleCapabilities
    costCalculationId
  }
}
    `;
 const CreateVehicles_MutationDocument = gql`
    mutation createVehicles_mutation($vehiclesInput: [CreateVehicleInput!]!) {
  createVehicles(vehiclesInput: $vehiclesInput) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const DeleteCarrier_MutationDocument = gql`
    mutation deleteCarrier_mutation($filter: ApiFilterOneCarrierInput!) {
  deleteCarrier(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const DeleteDispatchers_MutationDocument = gql`
    mutation deleteDispatchers_mutation($filter: FilterDeleteCarrierDispatcherInput!) {
  deleteDispatchers(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const DeleteEquipmentCharges_MutationDocument = gql`
    mutation deleteEquipmentCharges_mutation($filter: ApiFilterOneCarrierInput!, $rates: [RateEquipmentChargeInput!]!) {
  deleteEquipmentCharges(filter: $filter, rates: $rates) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const DeleteFleet_MutationDocument = gql`
    mutation deleteFleet_mutation($filter: FilterFleetInput!) {
  deleteFleet(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    name
    bodyType
    fleetDimensions {
      totalLoadingWeight
      totalLoadingHeight
      totalLoadingWidth
      totalLoadingLength
      fleetCapabilities
    }
    carriers {
      id
      name
    }
    possibleLocationIds
    possibleCountries
    externalReference
  }
}
    `;
 const DeleteFleets_MutationDocument = gql`
    mutation deleteFleets_mutation($filter: FilterFleetsInput!) {
  deleteFleets(filter: $filter) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const DeleteVehicle_MutationDocument = gql`
    mutation deleteVehicle_mutation($filter: FilterVehicleInput!) {
  deleteVehicle(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    name
    ldmm
    vehicleType
    maxLoadingWeight
    vehicleCapabilities
    costCalculationId
  }
}
    `;
 const DeleteVehicles_MutationDocument = gql`
    mutation deleteVehicles_mutation($filter: FilterVehiclesInput!) {
  deleteVehicles(filter: $filter) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const DisableCarrier_MutationDocument = gql`
    mutation disableCarrier_mutation($filter: ApiFilterOneCarrierInput!) {
  disableCarrier(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const EnableCarrier_MutationDocument = gql`
    mutation enableCarrier_mutation($filter: ApiFilterOneCarrierInput!) {
  enableCarrier(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const FindCarrier_QueryDocument = gql`
    query findCarrier_query($filter: ApiFilterOneCarrierInput!) {
  findCarrier(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const FindCarriers_QueryDocument = gql`
    query findCarriers_query($query: QueryCarriersInput!) {
  findCarriers(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      company {
        name
        contact {
          name
          mobile
          phone
          email
        }
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
      }
      dispatchers {
        id
        contact {
          name
          mobile
          phone
          email
        }
      }
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      preferredLanguage
      disabled
    }
  }
}
    `;
 const FindFleets_QueryDocument = gql`
    query findFleets_query($query: QueryFleetInput!) {
  findFleets(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      name
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      externalReference
    }
  }
}
    `;
 const FindVehicle_QueryDocument = gql`
    query findVehicle_query($filter: FilterVehicleInput!) {
  findVehicle(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    name
    ldmm
    vehicleType
    maxLoadingWeight
    vehicleCapabilities
    costCalculationId
  }
}
    `;
 const FindVehicles_QueryDocument = gql`
    query findVehicles_query($query: QueryVehiclesInput!) {
  findVehicles(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      name
      ldmm
      vehicleType
      maxLoadingWeight
      vehicleCapabilities
      costCalculationId
    }
  }
}
    `;
 const FindVehiclesByExternalReferences_QueryDocument = gql`
    query findVehiclesByExternalReferences_query($externalReferences: [String!]!) {
  findVehiclesByExternalReferences(externalReferences: $externalReferences) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      name
      ldmm
      vehicleType
      maxLoadingWeight
      vehicleCapabilities
      costCalculationId
    }
  }
}
    `;
 const ImportCarriers_MutationDocument = gql`
    mutation importCarriers_mutation($carriersImport: [CarrierImportWithIndexInput!]!) {
  importCarriers(carriersImport: $carriersImport) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const ImportRateLaneBased_MutationDocument = gql`
    mutation importRateLaneBased_mutation($filter: ApiFilterOneCarrierInput!, $rates: [ApiRateLaneBasedInput!]!) {
  importRateLaneBased(filter: $filter, rates: $rates) {
    successfulCount
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const RatesLookup_QueryDocument = gql`
    query ratesLookup_query($filter: ApiFilterOneCarrierInput!) {
  ratesLookup(filter: $filter) {
    perKm {
      minDistance
      costPerKm
    }
    unloadingCharges {
      costPerAdditionalStop
      isAppliedAtDepot
    }
    laneBased {
      id
      pickUp {
        country
        zipCode
      }
      dropOff {
        country
        zipCode
      }
      cost
      costWeight {
        valueFromLimit
        valueToLimit
        costMin
        costMax
        cost
      }
    }
    equipmentCharges {
      equipment
      rateType
      costPerEquipment
    }
    calculatedTotalCost
    agreedTotalCost
  }
}
    `;
 const RemoveRateLaneBased_MutationDocument = gql`
    mutation removeRateLaneBased_mutation($filter: ApiFilterOneCarrierRateInput!) {
  removeRateLaneBased(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const SeedVehiclesE2E_MutationDocument = gql`
    mutation seedVehiclesE2E_mutation {
  seedVehiclesE2E {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const UpdateCarrier_MutationDocument = gql`
    mutation updateCarrier_mutation($filter: ApiFilterOneCarrierInput!, $carrierInput: ApiCreateCarrierInput!) {
  updateCarrier(filter: $filter, carrierInput: $carrierInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const UpdateDispatcher_MutationDocument = gql`
    mutation updateDispatcher_mutation($filter: ApiFilterOneCarrierInput!, $dispatcherInput: ApiDispatcherInput!) {
  updateDispatcher(filter: $filter, dispatcherInput: $dispatcherInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const UpdateEquipmentCharge_MutationDocument = gql`
    mutation updateEquipmentCharge_mutation($filter: ApiFilterOneCarrierInput!, $rate: RateEquipmentChargeInput!) {
  updateEquipmentCharge(filter: $filter, rate: $rate) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const UpdateFleet_MutationDocument = gql`
    mutation updateFleet_mutation($filter: FilterFleetInput!, $fleetInput: UpdateFleetInput!) {
  updateFleet(filter: $filter, fleetInput: $fleetInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    name
    bodyType
    fleetDimensions {
      totalLoadingWeight
      totalLoadingHeight
      totalLoadingWidth
      totalLoadingLength
      fleetCapabilities
    }
    carriers {
      id
      name
    }
    possibleLocationIds
    possibleCountries
    externalReference
  }
}
    `;
 const UpdateRateLaneBased_MutationDocument = gql`
    mutation updateRateLaneBased_mutation($filter: ApiFilterOneCarrierRateInput!, $rate: ApiRateLaneBasedInput!) {
  updateRateLaneBased(filter: $filter, rate: $rate) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const UpdateRatePerKm_MutationDocument = gql`
    mutation updateRatePerKm_mutation($filter: ApiFilterOneCarrierInput!, $rates: [RatePerKmInput!]!) {
  updateRatePerKm(filter: $filter, rates: $rates) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const UpdateUnloadingCharges_MutationDocument = gql`
    mutation updateUnloadingCharges_mutation($filter: ApiFilterOneCarrierInput!, $rates: RateUnloadingChargesInput!) {
  updateUnloadingCharges(filter: $filter, rates: $rates) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
 const UpdateVehicle_MutationDocument = gql`
    mutation updateVehicle_mutation($filter: FilterVehicleInput!, $vehicleInput: UpdateVehicleInput!) {
  updateVehicle(filter: $filter, vehicleInput: $vehicleInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    name
    ldmm
    vehicleType
    maxLoadingWeight
    vehicleCapabilities
    costCalculationId
  }
}
    `;
 const CreateArticle_MutationDocument = gql`
    mutation createArticle_mutation($articleInput: CreateArticleInput!) {
  createArticle(articleInput: $articleInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    name
    weightInKgPerUnit
    packagingOptions {
      packaging {
        packagingCode
        packagingDescription
        articlesPerPackage
        maxStackSize
        dimensions {
          weight
          height
          width
          length
        }
        parent {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            liftingSide
          }
          quantityChildrenPerParent
        }
        liftingSide
      }
      maxStackSize
      articlesPerPackage
    }
  }
}
    `;
 const CreateArticles_MutationDocument = gql`
    mutation createArticles_mutation($articlesInput: [CreateArticleInput!]!) {
  createArticles(articlesInput: $articlesInput) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const CreateLoadV2_MutationDocument = gql`
    mutation createLoadV2_mutation($loadInput: CreateLoadInputV2!) {
  createLoadV2(loadInput: $loadInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    content
    loadingMillimeter
    weightInKg
    transportRequirements
    additionalInfo
    status
    statusChangedAt
    plannedFor
    pickUp {
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        loadedQuantity
      }
      order {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        deadline
        type
        status
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
          deadline
        }
        customerOrderReference
        customerComment
        internalComment
      }
    }
    dropOff {
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        loadedQuantity
      }
      order {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        deadline
        type
        status
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
          deadline
        }
        customerOrderReference
        customerComment
        internalComment
      }
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
  }
}
    `;
 const CreateLoadsV2_MutationDocument = gql`
    mutation createLoadsV2_mutation($loadsInput: [CreateLoadInputV2!]!) {
  createLoadsV2(loadsInput: $loadsInput) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const CreateLocationV2_MutationDocument = gql`
    mutation createLocationV2_mutation($locationInput: CreateLocationInputV2!) {
  createLocationV2(locationInput: $locationInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    owned
    company
    description
    loadingRequirements
    serviceTime
    address {
      street
      city
      zipCode
      country
      coordinates {
        latitude
        longitude
      }
    }
    contact {
      firstName
      lastName
      phone
      email
      role
    }
    openingHours {
      openingHoursType
      timezone
      openingHoursPerWeekDay {
        weekday
        from
        to
      }
    }
  }
}
    `;
 const CreateLocationsV2_MutationDocument = gql`
    mutation createLocationsV2_mutation($locationsInput: [CreateLocationInputV2!]!) {
  createLocationsV2(locationsInput: $locationsInput) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const CreateOrder_MutationDocument = gql`
    mutation createOrder_mutation($orderInput: CreateOrderInput!) {
  createOrder(orderInput: $orderInput) {
    id
  }
}
    `;
 const CreateOrders_MutationDocument = gql`
    mutation createOrders_mutation($ordersInput: [CreateOrderInput!]!) {
  createOrders(ordersInput: $ordersInput) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const CreatePackaging_MutationDocument = gql`
    mutation createPackaging_mutation($input: ArticleUnitInput!) {
  createPackaging(input: $input) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    packagingCode
    packagingDescription
    articlesPerPackage
    maxStackSize
    dimensions {
      weight
      height
      width
      length
    }
    liftingSide
    parent {
      packaging {
        packagingCode
        packagingDescription
        articlesPerPackage
        maxStackSize
        dimensions {
          weight
          height
          width
          length
        }
        liftingSide
      }
      quantityChildrenPerParent
    }
    tenantId
  }
}
    `;
 const DeleteArticle_MutationDocument = gql`
    mutation deleteArticle_mutation($filter: FilterArticleInput!) {
  deleteArticle(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    name
    weightInKgPerUnit
    packagingOptions {
      packaging {
        packagingCode
        packagingDescription
        articlesPerPackage
        maxStackSize
        dimensions {
          weight
          height
          width
          length
        }
        parent {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            liftingSide
          }
          quantityChildrenPerParent
        }
        liftingSide
      }
      maxStackSize
      articlesPerPackage
    }
  }
}
    `;
 const DeleteArticles_MutationDocument = gql`
    mutation deleteArticles_mutation($filter: FilterArticlesInput!) {
  deleteArticles(filter: $filter) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const DeleteLoadV2_MutationDocument = gql`
    mutation deleteLoadV2_mutation($filter: FilterLoadInput!) {
  deleteLoadV2(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    content
    loadingMillimeter
    weightInKg
    transportRequirements
    additionalInfo
    status
    statusChangedAt
    plannedFor
    pickUp {
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        loadedQuantity
      }
      order {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        deadline
        type
        status
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
          deadline
        }
        customerOrderReference
        customerComment
        internalComment
      }
    }
    dropOff {
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        loadedQuantity
      }
      order {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        deadline
        type
        status
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
          deadline
        }
        customerOrderReference
        customerComment
        internalComment
      }
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
  }
}
    `;
 const DeleteLoadsV2_MutationDocument = gql`
    mutation deleteLoadsV2_mutation($filter: FilterLoadsInput!) {
  deleteLoadsV2(filter: $filter) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const DeleteLocationV2_MutationDocument = gql`
    mutation deleteLocationV2_mutation($filter: FilterLocationInput!) {
  deleteLocationV2(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    owned
    company
    description
    loadingRequirements
    serviceTime
    address {
      street
      city
      zipCode
      country
      coordinates {
        latitude
        longitude
      }
    }
    contact {
      firstName
      lastName
      phone
      email
      role
    }
    openingHours {
      openingHoursType
      timezone
      openingHoursPerWeekDay {
        weekday
        from
        to
      }
    }
  }
}
    `;
 const DeleteLocationsV2_MutationDocument = gql`
    mutation deleteLocationsV2_mutation($filter: FilterLocationsInput!) {
  deleteLocationsV2(filter: $filter) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const DeleteOrder_MutationDocument = gql`
    mutation deleteOrder_mutation($filter: FilterOrderInput!) {
  deleteOrder(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    deadline
    type
    status
    location {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      owned
      company
      description
      loadingRequirements
      serviceTime
      address {
        street
        city
        zipCode
        country
        coordinates {
          latitude
          longitude
        }
      }
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      openingHours {
        openingHoursType
        timezone
        openingHoursPerWeekDay {
          weekday
          from
          to
        }
      }
    }
    articles {
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      totalQuantity
      totalLoadingMillimeter
      totalWeightInKg
      deadline
    }
    loads {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      content
      loadingMillimeter
      weightInKg
      transportRequirements
      additionalInfo
      status
      statusChangedAt
      plannedFor
      pickUp {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
      }
      dropOff {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
    }
    customerOrderReference
    customerComment
    internalComment
  }
}
    `;
 const DeleteOrders_MutationDocument = gql`
    mutation deleteOrders_mutation($filter: FilterOrdersInput!) {
  deleteOrders(filter: $filter) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const EstimateTravelDuration_QueryDocument = gql`
    query estimateTravelDuration_query($locationIds: [String!]!) {
  estimateTravelDuration(locationIds: $locationIds) {
    locationId
    drivingTime
    distance
  }
}
    `;
 const FindArticle_QueryDocument = gql`
    query findArticle_query($filter: FilterArticleInput!) {
  findArticle(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    name
    weightInKgPerUnit
    packagingOptions {
      packaging {
        packagingCode
        packagingDescription
        articlesPerPackage
        maxStackSize
        dimensions {
          weight
          height
          width
          length
        }
        parent {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            liftingSide
          }
          quantityChildrenPerParent
        }
        liftingSide
      }
      maxStackSize
      articlesPerPackage
    }
  }
}
    `;
 const FindArticles_QueryDocument = gql`
    query findArticles_query($query: QueryArticlesInput!) {
  findArticles(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      name
      weightInKgPerUnit
      packagingOptions {
        packaging {
          packagingCode
          packagingDescription
          articlesPerPackage
          maxStackSize
          dimensions {
            weight
            height
            width
            length
          }
          parent {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              liftingSide
            }
            quantityChildrenPerParent
          }
          liftingSide
        }
        maxStackSize
        articlesPerPackage
      }
    }
  }
}
    `;
 const FindArticlesByExternalReferences_QueryDocument = gql`
    query findArticlesByExternalReferences_query($externalReferences: [String!]!) {
  findArticlesByExternalReferences(externalReferences: $externalReferences) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      name
      weightInKgPerUnit
      packagingOptions {
        packaging {
          packagingCode
          packagingDescription
          articlesPerPackage
          maxStackSize
          dimensions {
            weight
            height
            width
            length
          }
          parent {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              liftingSide
            }
            quantityChildrenPerParent
          }
          liftingSide
        }
        maxStackSize
        articlesPerPackage
      }
    }
  }
}
    `;
 const FindLoadCountsByDepots_QueryDocument = gql`
    query findLoadCountsByDepots_query($filter: FilterLoadCountByDepotInput!) {
  findLoadCountsByDepots(filter: $filter) {
    depot {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      owned
      company
      description
      loadingRequirements
      serviceTime
      address {
        street
        city
        zipCode
        country
        coordinates {
          latitude
          longitude
        }
      }
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      openingHours {
        openingHoursType
        timezone
        openingHoursPerWeekDay {
          weekday
          from
          to
        }
      }
    }
    count
    date
  }
}
    `;
 const FindLoadV2_QueryDocument = gql`
    query findLoadV2_query($filter: FilterLoadInput!) {
  findLoadV2(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    content
    loadingMillimeter
    weightInKg
    transportRequirements
    additionalInfo
    status
    statusChangedAt
    plannedFor
    pickUp {
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        loadedQuantity
      }
      order {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        deadline
        type
        status
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
          deadline
        }
        customerOrderReference
        customerComment
        internalComment
      }
    }
    dropOff {
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        loadedQuantity
      }
      order {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        deadline
        type
        status
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
          deadline
        }
        customerOrderReference
        customerComment
        internalComment
      }
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
  }
}
    `;
 const FindLoadsByExternalReferencesV2_QueryDocument = gql`
    query findLoadsByExternalReferencesV2_query($externalReferences: [String!]!) {
  findLoadsByExternalReferencesV2(externalReferences: $externalReferences) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      content
      loadingMillimeter
      weightInKg
      transportRequirements
      additionalInfo
      status
      statusChangedAt
      plannedFor
      pickUp {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
        order {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          deadline
          type
          status
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            totalQuantity
            totalLoadingMillimeter
            totalWeightInKg
            deadline
          }
          customerOrderReference
          customerComment
          internalComment
        }
      }
      dropOff {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
        order {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          deadline
          type
          status
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            totalQuantity
            totalLoadingMillimeter
            totalWeightInKg
            deadline
          }
          customerOrderReference
          customerComment
          internalComment
        }
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
    }
  }
}
    `;
 const FindLoadsCount_QueryDocument = gql`
    query findLoadsCount_query($query: QueryLoadsInput!) {
  findLoadsCount(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      content
      loadingMillimeter
      weightInKg
      transportRequirements
      additionalInfo
      status
      statusChangedAt
      plannedFor
      pickUp {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
        order {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          deadline
          type
          status
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            totalQuantity
            totalLoadingMillimeter
            totalWeightInKg
            deadline
          }
          customerOrderReference
          customerComment
          internalComment
        }
      }
      dropOff {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
        order {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          deadline
          type
          status
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            totalQuantity
            totalLoadingMillimeter
            totalWeightInKg
            deadline
          }
          customerOrderReference
          customerComment
          internalComment
        }
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
    }
  }
}
    `;
 const FindLoadsV2_QueryDocument = gql`
    query findLoadsV2_query($query: QueryLoadsInput!) {
  findLoadsV2(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      content
      loadingMillimeter
      weightInKg
      transportRequirements
      additionalInfo
      status
      statusChangedAt
      plannedFor
      pickUp {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
        order {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          deadline
          type
          status
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            totalQuantity
            totalLoadingMillimeter
            totalWeightInKg
            deadline
          }
          customerOrderReference
          customerComment
          internalComment
        }
      }
      dropOff {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
        order {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          deadline
          type
          status
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            totalQuantity
            totalLoadingMillimeter
            totalWeightInKg
            deadline
          }
          customerOrderReference
          customerComment
          internalComment
        }
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
    }
  }
}
    `;
 const FindLocationV2_QueryDocument = gql`
    query findLocationV2_query($filter: FilterLocationInput!) {
  findLocationV2(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    owned
    company
    description
    loadingRequirements
    serviceTime
    address {
      street
      city
      zipCode
      country
      coordinates {
        latitude
        longitude
      }
    }
    contact {
      firstName
      lastName
      phone
      email
      role
    }
    openingHours {
      openingHoursType
      timezone
      openingHoursPerWeekDay {
        weekday
        from
        to
      }
    }
  }
}
    `;
 const FindLocationsByExternalReferencesV2_QueryDocument = gql`
    query findLocationsByExternalReferencesV2_query($externalReferences: [String!]!) {
  findLocationsByExternalReferencesV2(externalReferences: $externalReferences) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      owned
      company
      description
      loadingRequirements
      serviceTime
      address {
        street
        city
        zipCode
        country
        coordinates {
          latitude
          longitude
        }
      }
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      openingHours {
        openingHoursType
        timezone
        openingHoursPerWeekDay {
          weekday
          from
          to
        }
      }
    }
  }
}
    `;
 const FindLocationsV2_QueryDocument = gql`
    query findLocationsV2_query($query: QueryLocationsInput!) {
  findLocationsV2(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      owned
      company
      description
      loadingRequirements
      serviceTime
      address {
        street
        city
        zipCode
        country
        coordinates {
          latitude
          longitude
        }
      }
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      openingHours {
        openingHoursType
        timezone
        openingHoursPerWeekDay {
          weekday
          from
          to
        }
      }
    }
  }
}
    `;
 const FindOrder_QueryDocument = gql`
    query findOrder_query($filter: FilterOrderInput!) {
  findOrder(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    deadline
    type
    status
    location {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      owned
      company
      description
      loadingRequirements
      serviceTime
      address {
        street
        city
        zipCode
        country
        coordinates {
          latitude
          longitude
        }
      }
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      openingHours {
        openingHoursType
        timezone
        openingHoursPerWeekDay {
          weekday
          from
          to
        }
      }
    }
    articles {
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      totalQuantity
      totalLoadingMillimeter
      totalWeightInKg
      deadline
    }
    loads {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      content
      loadingMillimeter
      weightInKg
      transportRequirements
      additionalInfo
      status
      statusChangedAt
      plannedFor
      pickUp {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
      }
      dropOff {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
    }
    customerOrderReference
    customerComment
    internalComment
  }
}
    `;
 const FindOrders_QueryDocument = gql`
    query findOrders_query($query: QueryOrdersInput!) {
  findOrders(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      deadline
      type
      status
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        totalQuantity
        totalLoadingMillimeter
        totalWeightInKg
        deadline
      }
      loads {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        content
        loadingMillimeter
        weightInKg
        transportRequirements
        additionalInfo
        status
        statusChangedAt
        plannedFor
        pickUp {
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          timeWindow {
            start
            end
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            loadedQuantity
          }
        }
        dropOff {
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          timeWindow {
            start
            end
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            loadedQuantity
          }
        }
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
            }
          }
        }
      }
      customerOrderReference
      customerComment
      internalComment
    }
  }
}
    `;
 const FindOrdersByExternalReferences_QueryDocument = gql`
    query findOrdersByExternalReferences_query($externalReferences: [String!]!) {
  findOrdersByExternalReferences(externalReferences: $externalReferences) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      deadline
      type
      status
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        totalQuantity
        totalLoadingMillimeter
        totalWeightInKg
        deadline
      }
      loads {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        content
        loadingMillimeter
        weightInKg
        transportRequirements
        additionalInfo
        status
        statusChangedAt
        plannedFor
        pickUp {
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          timeWindow {
            start
            end
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            loadedQuantity
          }
        }
        dropOff {
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          timeWindow {
            start
            end
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            loadedQuantity
          }
        }
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
            }
          }
        }
      }
      customerOrderReference
      customerComment
      internalComment
    }
  }
}
    `;
 const FindPackages_QueryDocument = gql`
    query findPackages_query($query: QueryPackagingInput!) {
  findPackages(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      packagingCode
      packagingDescription
      articlesPerPackage
      maxStackSize
      dimensions {
        weight
        height
        width
        length
      }
      liftingSide
      parent {
        packaging {
          packagingCode
          packagingDescription
          articlesPerPackage
          maxStackSize
          dimensions {
            weight
            height
            width
            length
          }
          liftingSide
        }
        quantityChildrenPerParent
      }
      tenantId
    }
  }
}
    `;
 const GetLocationMasterDataInfo_QueryDocument = gql`
    query getLocationMasterDataInfo_query($filter: FilterLocationMasterDataInput!) {
  getLocationMasterDataInfo(filter: $filter) {
    infoType
    count
  }
}
    `;
 const ImportArticles_MutationDocument = gql`
    mutation importArticles_mutation($articlesInput: [CreateArticleInput!]!) {
  importArticles(articlesInput: $articlesInput) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const ImportLoadLocations_MutationDocument = gql`
    mutation importLoadLocations_mutation($locationsImport: [LoadLocationImportInput!]!) {
  importLoadLocations(locationsImport: $locationsImport) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const ImportLoadsV2_MutationDocument = gql`
    mutation importLoadsV2_mutation($loadsImport: [LoadImportInput!]!) {
  importLoadsV2(loadsImport: $loadsImport) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const ImportLocationsV2_MutationDocument = gql`
    mutation importLocationsV2_mutation($locationsImport: [LocationImportWithIndexInput!]!) {
  importLocationsV2(locationsImport: $locationsImport) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const ImportOrders_MutationDocument = gql`
    mutation importOrders_mutation($ordersImport: [OrderImportInput!]!) {
  importOrders(ordersImport: $ordersImport) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const ImportPackaging_MutationDocument = gql`
    mutation importPackaging_mutation($input: [ArticleUnitInput!]!) {
  importPackaging(input: $input) {
    successfulCount
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const MatchOrder_MutationDocument = gql`
    mutation matchOrder_mutation($filter: FilterOrderInput!, $matchInput: MatchOrderInput!) {
  matchOrder(filter: $filter, matchInput: $matchInput) {
    order {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      deadline
      type
      status
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        totalQuantity
        totalLoadingMillimeter
        totalWeightInKg
        deadline
      }
      loads {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        content
        loadingMillimeter
        weightInKg
        transportRequirements
        additionalInfo
        status
        statusChangedAt
        plannedFor
        pickUp {
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          timeWindow {
            start
            end
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            loadedQuantity
          }
        }
        dropOff {
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          timeWindow {
            start
            end
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            loadedQuantity
          }
        }
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
            }
          }
        }
      }
      customerOrderReference
      customerComment
      internalComment
    }
    loadIds
  }
}
    `;
 const SeedLoads_MutationDocument = gql`
    mutation seedLoads_mutation {
  seedLoads {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const SeedLocations_MutationDocument = gql`
    mutation seedLocations_mutation {
  seedLocations {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
 const UnmatchOrder_MutationDocument = gql`
    mutation unmatchOrder_mutation($filter: FilterOrderInput!) {
  unmatchOrder(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    deadline
    type
    status
    location {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      owned
      company
      description
      loadingRequirements
      serviceTime
      address {
        street
        city
        zipCode
        country
        coordinates {
          latitude
          longitude
        }
      }
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      openingHours {
        openingHoursType
        timezone
        openingHoursPerWeekDay {
          weekday
          from
          to
        }
      }
    }
    articles {
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      totalQuantity
      totalLoadingMillimeter
      totalWeightInKg
      deadline
    }
    loads {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      content
      loadingMillimeter
      weightInKg
      transportRequirements
      additionalInfo
      status
      statusChangedAt
      plannedFor
      pickUp {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
      }
      dropOff {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
    }
    customerOrderReference
    customerComment
    internalComment
  }
}
    `;
 const UpdateArticle_MutationDocument = gql`
    mutation updateArticle_mutation($filter: FilterArticleInput!, $articleInput: UpdateArticleInput!) {
  updateArticle(filter: $filter, articleInput: $articleInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    name
    weightInKgPerUnit
    packagingOptions {
      packaging {
        packagingCode
        packagingDescription
        articlesPerPackage
        maxStackSize
        dimensions {
          weight
          height
          width
          length
        }
        parent {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            liftingSide
          }
          quantityChildrenPerParent
        }
        liftingSide
      }
      maxStackSize
      articlesPerPackage
    }
  }
}
    `;
 const UpdateLoadV2_MutationDocument = gql`
    mutation updateLoadV2_mutation($filter: FilterLoadInput!, $loadInput: UpdateLoadInputV2!) {
  updateLoadV2(filter: $filter, loadInput: $loadInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    content
    loadingMillimeter
    weightInKg
    transportRequirements
    additionalInfo
    status
    statusChangedAt
    plannedFor
    pickUp {
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        loadedQuantity
      }
      order {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        deadline
        type
        status
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
          deadline
        }
        customerOrderReference
        customerComment
        internalComment
      }
    }
    dropOff {
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        loadedQuantity
      }
      order {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        deadline
        type
        status
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
          deadline
        }
        customerOrderReference
        customerComment
        internalComment
      }
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
  }
}
    `;
 const UpdateLocationV2_MutationDocument = gql`
    mutation updateLocationV2_mutation($filter: FilterLocationInput!, $locationInput: UpdateLocationInputV2!) {
  updateLocationV2(filter: $filter, locationInput: $locationInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    owned
    company
    description
    loadingRequirements
    serviceTime
    address {
      street
      city
      zipCode
      country
      coordinates {
        latitude
        longitude
      }
    }
    contact {
      firstName
      lastName
      phone
      email
      role
    }
    openingHours {
      openingHoursType
      timezone
      openingHoursPerWeekDay {
        weekday
        from
        to
      }
    }
  }
}
    `;
 const UpdateOrder_MutationDocument = gql`
    mutation updateOrder_mutation($filter: FilterOrderInput!, $orderInput: UpdateOrderInput!) {
  updateOrder(filter: $filter, orderInput: $orderInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    deadline
    type
    status
    location {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      owned
      company
      description
      loadingRequirements
      serviceTime
      address {
        street
        city
        zipCode
        country
        coordinates {
          latitude
          longitude
        }
      }
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      openingHours {
        openingHoursType
        timezone
        openingHoursPerWeekDay {
          weekday
          from
          to
        }
      }
    }
    articles {
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      totalQuantity
      totalLoadingMillimeter
      totalWeightInKg
      deadline
    }
    loads {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      content
      loadingMillimeter
      weightInKg
      transportRequirements
      additionalInfo
      status
      statusChangedAt
      plannedFor
      pickUp {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
      }
      dropOff {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
    }
    customerOrderReference
    customerComment
    internalComment
  }
}
    `;
 const CreateOrderPlanningVehicle_MutationDocument = gql`
    mutation createOrderPlanningVehicle_mutation($orderPlanningVehicleInput: CreateOrderPlanningVehicleInput!) {
  createOrderPlanningVehicle(
    orderPlanningVehicleInput: $orderPlanningVehicleInput
  ) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    name
    totalCapacity {
      loadingMillimeter
      weightInKg
    }
    loadIds
    pickUpLocationId
    tourStartTime
    calendarWeek
    status
    dropOffStops {
      locationId
      plannedArrivalTime
    }
    carrier {
      name
      cost
      comment
    }
    exportedAt
  }
}
    `;
 const DeleteOrderPlanningVehicle_MutationDocument = gql`
    mutation deleteOrderPlanningVehicle_mutation($filter: FilterOrderPlanningVehicleInput!) {
  deleteOrderPlanningVehicle(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    name
    totalCapacity {
      loadingMillimeter
      weightInKg
    }
    loadIds
    pickUpLocationId
    tourStartTime
    calendarWeek
    status
    dropOffStops {
      locationId
      plannedArrivalTime
    }
    carrier {
      name
      cost
      comment
    }
    exportedAt
  }
}
    `;
 const FindOrderPlanningVehicle_QueryDocument = gql`
    query findOrderPlanningVehicle_query($filter: FilterOrderPlanningVehicleInput!) {
  findOrderPlanningVehicle(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    name
    totalCapacity {
      loadingMillimeter
      weightInKg
    }
    loadIds
    pickUpLocationId
    tourStartTime
    calendarWeek
    status
    dropOffStops {
      locationId
      plannedArrivalTime
    }
    carrier {
      name
      cost
      comment
    }
    exportedAt
  }
}
    `;
 const FindOrderPlanningVehicles_QueryDocument = gql`
    query findOrderPlanningVehicles_query($query: QueryOrderPlanningVehiclesInput!) {
  findOrderPlanningVehicles(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      name
      totalCapacity {
        loadingMillimeter
        weightInKg
      }
      loadIds
      pickUpLocationId
      tourStartTime
      calendarWeek
      status
      dropOffStops {
        locationId
        plannedArrivalTime
      }
      carrier {
        name
        cost
        comment
      }
      exportedAt
    }
  }
}
    `;
 const GetOrderPlanningLoadsInfo_QueryDocument = gql`
    query getOrderPlanningLoadsInfo_query($loadIds: [String!]!) {
  getOrderPlanningLoadsInfo(loadIds: $loadIds) {
    loadId
    loadStatus
    exportedAt
  }
}
    `;
 const UpdateOrderPlanningVehicle_MutationDocument = gql`
    mutation updateOrderPlanningVehicle_mutation($filter: FilterOrderPlanningVehicleInput!, $orderPlanningVehicleInput: UpdateOrderPlanningVehicleInput!) {
  updateOrderPlanningVehicle(
    filter: $filter
    orderPlanningVehicleInput: $orderPlanningVehicleInput
  ) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    name
    totalCapacity {
      loadingMillimeter
      weightInKg
    }
    loadIds
    pickUpLocationId
    tourStartTime
    calendarWeek
    status
    dropOffStops {
      locationId
      plannedArrivalTime
    }
    carrier {
      name
      cost
      comment
    }
    exportedAt
  }
}
    `;
 const BookCargoboardOrder_MutationDocument = gql`
    mutation bookCargoboardOrder_mutation($shipmentId: String!, $loadingType: LoadingUnloadingTypes) {
  bookCargoboardOrder(shipmentId: $shipmentId, loadingType: $loadingType) {
    id
    product
    truckType
    price {
      amount
      currency
    }
    priceStandard {
      amount
      currency
    }
    pickupOn
    pickupAtFrom
    pickupAtUntil
    runtime {
      daysMin
      daysMax
    }
    delivery {
      earliest
      latest
    }
    costItems {
      description
      type
      subtype
      price {
        amount
        currency
      }
    }
    co2Emission {
      amount
      value
      unit
    }
    reference
  }
}
    `;
 const CancelCargoboardOrder_MutationDocument = gql`
    mutation cancelCargoboardOrder_mutation($shipmentId: String!, $cargoboardId: String!) {
  cancelCargoboardOrder(shipmentId: $shipmentId, cargoboardId: $cargoboardId)
}
    `;
 const CountShipmentByStatus_QueryDocument = gql`
    query countShipmentByStatus_query($filter: ShipmentStatusCountFilterInput!) {
  countShipmentByStatus(filter: $filter) {
    status
    count
  }
}
    `;
 const CreateShipment_MutationDocument = gql`
    mutation createShipment_mutation($shipmentInput: CreateShipmentInput!) {
  createShipment(shipmentInput: $shipmentInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const DeleteShipment_MutationDocument = gql`
    mutation deleteShipment_mutation($filter: FilterShipmentInput!) {
  deleteShipment(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const FindCargoboardQuotation_QueryDocument = gql`
    query findCargoboardQuotation_query($filter: FilterShipmentInput!) {
  findCargoboardQuotation(filter: $filter) {
    loadingType
    quotationId
    costItems {
      description
      type
      amount
    }
    amount
    currency
  }
}
    `;
 const FindCustomerShipmentTracking_QueryDocument = gql`
    query findCustomerShipmentTracking_query($filter: FilterShipmentStopInput!) {
  findCustomerShipmentTracking(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const FindShipment_QueryDocument = gql`
    query findShipment_query($filter: FilterShipmentInput!) {
  findShipment(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const FindShipmentOrderRequest_QueryDocument = gql`
    query findShipmentOrderRequest_query($data: String!) {
  findShipmentOrderRequest(data: $data) {
    shipment {
      id
      version
      createdAt
      updatedAt
      deletedAt
      assignment {
        carrier {
          name
          address {
            street
            houseNumber
            city
            zipCode
            country
          }
          contact {
            name
            mobile
            phone
            email
          }
        }
        dispatcher {
          contact {
            name
            mobile
            phone
            email
          }
        }
        referenceId
        rate {
          perKm {
            minDistance
            costPerKm
          }
          unloadingCharges {
            costPerAdditionalStop
            isAppliedAtDepot
          }
          laneBased {
            id
            pickUp {
              country
              zipCode
            }
            dropOff {
              country
              zipCode
            }
            cost
            costWeight {
              valueFromLimit
              valueToLimit
              costMin
              costMax
              cost
            }
          }
          equipmentCharges {
            equipment
            rateType
            costPerEquipment
          }
          calculatedTotalCost
          agreedTotalCost
        }
        costAdjustment {
          type
          amount
        }
        assignedAt
        preferredLanguage
        status
      }
      requests {
        carrier {
          name
          address {
            street
            houseNumber
            city
            zipCode
            country
          }
          contact {
            name
            mobile
            phone
            email
          }
        }
        dispatcher {
          contact {
            name
            mobile
            phone
            email
          }
        }
        referenceId
        rate {
          perKm {
            minDistance
            costPerKm
          }
          unloadingCharges {
            costPerAdditionalStop
            isAppliedAtDepot
          }
          laneBased {
            id
            pickUp {
              country
              zipCode
            }
            dropOff {
              country
              zipCode
            }
            cost
            costWeight {
              valueFromLimit
              valueToLimit
              costMin
              costMax
              cost
            }
          }
          equipmentCharges {
            equipment
            rateType
            costPerEquipment
          }
          calculatedTotalCost
          agreedTotalCost
        }
        costAdjustment {
          type
          amount
        }
        assignedAt
        preferredLanguage
        status
      }
      driver {
        name
        phone
        email
      }
      tenantId
      flagged
      status
      stops {
        id
        location {
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          loadingRequirements
          serviceTime
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        pickUp {
          referenceId
          customerReference
          content
          article
          pallets
          weight
          ldmm
        }
        dropOff {
          referenceId
          customerReference
          content
          article
          pallets
          weight
          ldmm
        }
        estimatedTimes {
          estimatedArrivalTime
          estimatedDepartureTime
          comment
        }
        status
        completion {
          actualDepartureTime
          inFull
          comment
        }
        actualArrivalTime
        plannedTimes {
          plannedArrivalTime
          plannedDepartureTime
        }
        proofOfDeliveryUrl
      }
      transportRequirements {
        requiredPalletCapacity
        requiredWeightCapacity
        requiredLdmCapacity
        loadingRequirements
      }
      incidents {
        id
        userId
        tenantId
        timestamp
        comment
        stopId
      }
      referenceId
      distance
      vehicle {
        referenceId
        vehicleType
        vehicleLicense
        trailerLicense
        dimension {
          totalLoadingWeight
          totalLoadingHeight
          totalLoadingWidth
          totalLoadingLength
          fleetCapabilities
        }
        name
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
      enRoute {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
      anonymousLink
      transportAllocationId
      cargoboardId
      transportOrderdocuments
      applicationDeadline
    }
    shipper {
      id
      name
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
      contact {
        name
        mobile
        phone
        email
      }
      language
      taxId
    }
    expiresAt
    logoUri
    carrierReferenceId
  }
}
    `;
 const FindShipments_QueryDocument = gql`
    query findShipments_query($query: QueryShipmentsInput!) {
  findShipments(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      assignment {
        carrier {
          name
          address {
            street
            houseNumber
            city
            zipCode
            country
          }
          contact {
            name
            mobile
            phone
            email
          }
        }
        dispatcher {
          contact {
            name
            mobile
            phone
            email
          }
        }
        referenceId
        rate {
          perKm {
            minDistance
            costPerKm
          }
          unloadingCharges {
            costPerAdditionalStop
            isAppliedAtDepot
          }
          laneBased {
            id
            pickUp {
              country
              zipCode
            }
            dropOff {
              country
              zipCode
            }
            cost
            costWeight {
              valueFromLimit
              valueToLimit
              costMin
              costMax
              cost
            }
          }
          equipmentCharges {
            equipment
            rateType
            costPerEquipment
          }
          calculatedTotalCost
          agreedTotalCost
        }
        costAdjustment {
          type
          amount
        }
        assignedAt
        preferredLanguage
        status
      }
      requests {
        carrier {
          name
          address {
            street
            houseNumber
            city
            zipCode
            country
          }
          contact {
            name
            mobile
            phone
            email
          }
        }
        dispatcher {
          contact {
            name
            mobile
            phone
            email
          }
        }
        referenceId
        rate {
          perKm {
            minDistance
            costPerKm
          }
          unloadingCharges {
            costPerAdditionalStop
            isAppliedAtDepot
          }
          laneBased {
            id
            pickUp {
              country
              zipCode
            }
            dropOff {
              country
              zipCode
            }
            cost
            costWeight {
              valueFromLimit
              valueToLimit
              costMin
              costMax
              cost
            }
          }
          equipmentCharges {
            equipment
            rateType
            costPerEquipment
          }
          calculatedTotalCost
          agreedTotalCost
        }
        costAdjustment {
          type
          amount
        }
        assignedAt
        preferredLanguage
        status
      }
      driver {
        name
        phone
        email
      }
      tenantId
      flagged
      status
      stops {
        id
        location {
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          loadingRequirements
          serviceTime
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        pickUp {
          referenceId
          customerReference
          content
          article
          pallets
          weight
          ldmm
        }
        dropOff {
          referenceId
          customerReference
          content
          article
          pallets
          weight
          ldmm
        }
        estimatedTimes {
          estimatedArrivalTime
          estimatedDepartureTime
          comment
        }
        status
        completion {
          actualDepartureTime
          inFull
          comment
        }
        actualArrivalTime
        plannedTimes {
          plannedArrivalTime
          plannedDepartureTime
        }
        proofOfDeliveryUrl
      }
      transportRequirements {
        requiredPalletCapacity
        requiredWeightCapacity
        requiredLdmCapacity
        loadingRequirements
      }
      incidents {
        id
        userId
        tenantId
        timestamp
        comment
        stopId
      }
      referenceId
      distance
      vehicle {
        referenceId
        vehicleType
        vehicleLicense
        trailerLicense
        dimension {
          totalLoadingWeight
          totalLoadingHeight
          totalLoadingWidth
          totalLoadingLength
          fleetCapabilities
        }
        name
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
      enRoute {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
      anonymousLink
      transportAllocationId
      cargoboardId
      transportOrderdocuments
      applicationDeadline
    }
  }
}
    `;
 const LoginWithApi_MutationDocument = gql`
    mutation loginWithApi_mutation($apiKey: String!) {
  loginWithApi(apiKey: $apiKey)
}
    `;
 const RegisterCargoboardCompany_MutationDocument = gql`
    mutation registerCargoboardCompany_mutation($registerInput: CargoboardRegisterInput!) {
  registerCargoboardCompany(registerInput: $registerInput) {
    companyName
    apiKey
  }
}
    `;
 const ReportIncident_MutationDocument = gql`
    mutation reportIncident_mutation($filter: FilterShipmentOptionalStopInput!, $incident: ShipmentIncidentInput!) {
  reportIncident(filter: $filter, incident: $incident) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const SetRequestAccepted_MutationDocument = gql`
    mutation setRequestAccepted_mutation($decyptedInput: String!, $filter: FilterShipmentInput!, $assignment: ShipmentAssignmentInput!, $isAccept: Boolean!) {
  setRequestAccepted(
    decyptedInput: $decyptedInput
    filter: $filter
    assignment: $assignment
    isAccept: $isAccept
  ) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const SetShipmentStatusAllocatedDirectly_MutationDocument = gql`
    mutation setShipmentStatusAllocatedDirectly_mutation($filter: FilterShipmentInput!, $assignment: ShipmentAssignmentInput!, $shipper: ShipperInput!) {
  setShipmentStatusAllocatedDirectly(
    filter: $filter
    assignment: $assignment
    shipper: $shipper
  ) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const SetShipmentStatusCancelled_MutationDocument = gql`
    mutation setShipmentStatusCancelled_mutation($filter: FilterShipmentInput!, $comment: String) {
  setShipmentStatusCancelled(filter: $filter, comment: $comment) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const SetShipmentStatusCompleted_MutationDocument = gql`
    mutation setShipmentStatusCompleted_mutation($filter: FilterShipmentInput!) {
  setShipmentStatusCompleted(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const SetShipmentStatusCreated_MutationDocument = gql`
    mutation setShipmentStatusCreated_mutation($filter: FilterShipmentInput!) {
  setShipmentStatusCreated(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const SetShipmentStatusInTransit_MutationDocument = gql`
    mutation setShipmentStatusInTransit_mutation($filter: FilterShipmentInput!) {
  setShipmentStatusInTransit(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const SetShipmentStatusRequestRevoked_MutationDocument = gql`
    mutation setShipmentStatusRequestRevoked_mutation($filter: FilterShipmentInput!, $assignmentId: String!, $shipper: ShipperInput!) {
  setShipmentStatusRequestRevoked(
    filter: $filter
    assignmentId: $assignmentId
    shipper: $shipper
  ) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const SetShipmentStatusRequested_MutationDocument = gql`
    mutation setShipmentStatusRequested_mutation($filter: FilterShipmentInput!, $assignments: [ShipmentAssignmentInput!]!, $shipper: ShipperInput!, $applicationDeadline: DateTime!) {
  setShipmentStatusRequested(
    filter: $filter
    assignments: $assignments
    shipper: $shipper
    applicationDeadline: $applicationDeadline
  ) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const SetShipmentStopStatusCancelled_MutationDocument = gql`
    mutation setShipmentStopStatusCancelled_mutation($filter: FilterShipmentStopInput!, $comment: String) {
  setShipmentStopStatusCancelled(filter: $filter, comment: $comment) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const SetShipmentStopStatusCompleted_MutationDocument = gql`
    mutation setShipmentStopStatusCompleted_mutation($filter: FilterShipmentStopInput!, $completion: ShipmentStopCompletionInput!) {
  setShipmentStopStatusCompleted(filter: $filter, completion: $completion) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const SignedBucketUrl_QueryDocument = gql`
    query signedBucketUrl_query($url: String!) {
  signedBucketUrl(url: $url)
}
    `;
 const UnassignCarrier_MutationDocument = gql`
    mutation unassignCarrier_mutation($filter: FilterShipmentInput!) {
  unassignCarrier(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const UpdateReferenceId_MutationDocument = gql`
    mutation updateReferenceId_mutation($filter: FilterShipmentInput!, $referenceId: String!) {
  updateReferenceId(filter: $filter, referenceId: $referenceId) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const UpdateShipmentDriver_MutationDocument = gql`
    mutation updateShipmentDriver_mutation($filter: FilterShipmentInput!, $driver: ShipmentDriverInput!) {
  updateShipmentDriver(filter: $filter, driver: $driver) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const UpdateShipmentStopActualArrivalTime_MutationDocument = gql`
    mutation updateShipmentStopActualArrivalTime_mutation($filter: FilterShipmentStopInput!, $actualArrivalTime: DateTime!, $comment: String) {
  updateShipmentStopActualArrivalTime(
    filter: $filter
    actualArrivalTime: $actualArrivalTime
    comment: $comment
  ) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const UpdateShipmentStopsEstimatedTimes_MutationDocument = gql`
    mutation updateShipmentStopsEstimatedTimes_mutation($filter: FilterShipmentOptionalStopInput!, $estimatedTimes: ShipmentStopEstimatedTimesInput) {
  updateShipmentStopsEstimatedTimes(
    filter: $filter
    estimatedTimes: $estimatedTimes
  ) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const UpdateShipmentVehicle_MutationDocument = gql`
    mutation updateShipmentVehicle_mutation($filter: FilterShipmentInput!, $vehicle: ShipmentVehicleInput!) {
  updateShipmentVehicle(filter: $filter, vehicle: $vehicle) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
 const CompleteRegistration_MutationDocument = gql`
    mutation completeRegistration_mutation($details: ApiRegistrationInput!) {
  completeRegistration(details: $details) {
    message
  }
}
    `;
 const DeleteInvitation_MutationDocument = gql`
    mutation deleteInvitation_mutation($details: ApiDeleteInvitationInput!) {
  deleteInvitation(details: $details) {
    message
  }
}
    `;
 const GetDecryptedPayload_QueryDocument = gql`
    query getDecryptedPayload_query($payload: String!) {
  getDecryptedPayload(payload: $payload) {
    payload
  }
}
    `;
 const GetLogoUrl_QueryDocument = gql`
    query getLogoUrl_query($userId: String!, $tenantId: String!) {
  getLogoUrl(userId: $userId, tenantId: $tenantId)
}
    `;
 const GetMe_QueryDocument = gql`
    query getMe_query {
  getMe {
    id
    username
    name
    firstName
    lastName
    email
    language
    status
    userType
    createdDate
    invitedOn
    emailVerified
  }
}
    `;
 const GetMyTenant_QueryDocument = gql`
    query getMyTenant_query {
  getMyTenant {
    id
    name
    street
    city
    zipCode
    country
    taxId
    dashboardId
    logoUrl
    cargoboardApiKey
  }
}
    `;
 const GetMyTenantUsers_QueryDocument = gql`
    query getMyTenantUsers_query($query: QueryUsersInput!) {
  getMyTenantUsers(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      username
      name
      firstName
      lastName
      email
      language
      status
      userType
      createdDate
      invitedOn
      emailVerified
    }
  }
}
    `;
 const ResendInvitation_MutationDocument = gql`
    mutation resendInvitation_mutation($details: ApiResendInvitationInput!) {
  resendInvitation(details: $details) {
    message
  }
}
    `;
 const ResetPassword_MutationDocument = gql`
    mutation resetPassword_mutation($details: ApiResetPasswordInput!) {
  resetPassword(details: $details) {
    message
  }
}
    `;
 const SendInvitation_MutationDocument = gql`
    mutation sendInvitation_mutation($details: ApiInvitationInput!) {
  sendInvitation(details: $details) {
    message
  }
}
    `;
 const SendPasswordResetEmail_MutationDocument = gql`
    mutation sendPasswordResetEmail_mutation($details: ApiResetPasswordEmailInput!) {
  sendPasswordResetEmail(details: $details) {
    message
  }
}
    `;
 const SignedTenantBucketUrl_QueryDocument = gql`
    query signedTenantBucketUrl_query($url: String!) {
  signedTenantBucketUrl(url: $url)
}
    `;
 const UpdateMe_MutationDocument = gql`
    mutation updateMe_mutation($details: ApiUserInput!) {
  updateMe(details: $details) {
    message
  }
}
    `;
 const UpdateMyTenant_MutationDocument = gql`
    mutation updateMyTenant_mutation($details: ApiTenantInput!) {
  updateMyTenant(details: $details) {
    message
  }
}
    `;
 const UpdateUserByAdmin_MutationDocument = gql`
    mutation updateUserByAdmin_mutation($details: ApiUpdateUserByAdmin!) {
  updateUserByAdmin(details: $details) {
    message
  }
}
    `;
 const AddFleetsToTourPlan_MutationDocument = gql`
    mutation addFleetsToTourPlan_mutation($tourPlanId: String!, $addFleetInputs: [TourPlannerAddFleetInput!]!) {
  addFleetsToTourPlan(tourPlanId: $tourPlanId, addFleetInputs: $addFleetInputs) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const AddLoadToFleet_MutationDocument = gql`
    mutation addLoadToFleet_mutation($load: TourPlannerLoadInput!, $fleetId: String!, $tourPlanId: String!) {
  addLoadToFleet(load: $load, fleetId: $fleetId, tourPlanId: $tourPlanId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const AddLoadToTour_MutationDocument = gql`
    mutation addLoadToTour_mutation($tourPlanId: String!, $load: TourPlannerLoadInput!, $tourId: String!, $index: Int) {
  addLoadToTour(
    tourPlanId: $tourPlanId
    load: $load
    tourId: $tourId
    index: $index
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const AddLoadToVehicle_MutationDocument = gql`
    mutation addLoadToVehicle_mutation($load: TourPlannerLoadInput!, $vehicleId: String!, $tourPlanId: String!) {
  addLoadToVehicle(load: $load, vehicleId: $vehicleId, tourPlanId: $tourPlanId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const AssignUnplannedLoads_MutationDocument = gql`
    mutation assignUnplannedLoads_mutation($tourPlanId: String!, $settings: TourSettingsInput!, $loads: [TourPlannerLoadInput!]!) {
  assignUnplannedLoads(
    tourPlanId: $tourPlanId
    settings: $settings
    loads: $loads
  ) {
    tourPlan {
      id
      name
      tenantId
      planningDate
      vehicles {
        id
        name
        vehicleType
        maxLoadingWeight
        ldmm
        pallets
        vehicleCapabilities
        tours {
          id
          stops {
            id
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            reference
            earliestPlannedArrivalTime
            latestPlannedArrivalTime
            serviceTime
            loads {
              id
              pickUp {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              dropOff {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              loadingMillimeter
              article {
                id
                packagingOptions {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    parent {
                      packaging {
                        packagingCode
                        packagingDescription
                        articlesPerPackage
                        maxStackSize
                        dimensions {
                          weight
                          height
                          width
                          length
                        }
                        liftingSide
                      }
                      quantityChildrenPerParent
                    }
                    liftingSide
                  }
                  maxStackSize
                  articlesPerPackage
                }
                externalReference
                name
                weightInKgPerUnit
              }
              pallets
              weight
              customerReference
              content
              transportRequirements
              stackable
              articleNumber
              articleName
              articleQuantity
              orderReference
              additionalInfo
            }
            distance
          }
          distance
          route {
            sections {
              polyline
              summary {
                duration
                length
                consumption
                co2Emission
              }
              aggregateTolls {
                countryCode
                tollSystem
                currency
                value
              }
            }
          }
          shipment {
            id
            createdAt
          }
          lock {
            createdAt
            lockReason
          }
        }
      }
      fleets {
        id
        name
        fleetTemplateId
        bodyType
        fleetDimensions {
          totalLoadingWeight
          totalLoadingHeight
          totalLoadingWidth
          totalLoadingLength
          fleetCapabilities
        }
        carriers {
          id
          name
        }
        possibleLocationIds
        possibleCountries
        tours {
          id
          stops {
            id
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            reference
            earliestPlannedArrivalTime
            latestPlannedArrivalTime
            serviceTime
            loads {
              id
              pickUp {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              dropOff {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              loadingMillimeter
              article {
                id
                packagingOptions {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    parent {
                      packaging {
                        packagingCode
                        packagingDescription
                        articlesPerPackage
                        maxStackSize
                        dimensions {
                          weight
                          height
                          width
                          length
                        }
                        liftingSide
                      }
                      quantityChildrenPerParent
                    }
                    liftingSide
                  }
                  maxStackSize
                  articlesPerPackage
                }
                externalReference
                name
                weightInKgPerUnit
              }
              pallets
              weight
              customerReference
              content
              transportRequirements
              stackable
              articleNumber
              articleName
              articleQuantity
              orderReference
              additionalInfo
            }
            distance
          }
          distance
          route {
            sections {
              polyline
              summary {
                duration
                length
                consumption
                co2Emission
              }
              aggregateTolls {
                countryCode
                tollSystem
                currency
                value
              }
            }
          }
          shipment {
            id
            createdAt
          }
          lock {
            createdAt
            lockReason
          }
        }
      }
      configuration {
        maxDrivingHours
        maxWorkingHours
        cutOffTimeHours
        warningTimeHours
        toursAlwaysStartAtDepot
        toursAlwaysEndAtDepot
      }
      lastPlannedTourExecutionTime
      lockedAtTime
      lockedTimeout
      lock {
        createdAt
        timeout
        reason
      }
      unplannedLoads {
        id
        pickUp {
          id
          location {
            id
            externalReference
            company
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            owned
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            serviceTime
            timeWindows {
              weekday
              from
              to
            }
            timezone
            loadingRequirements
            timeWindowType
          }
          timeWindow {
            id
            start
            end
          }
        }
        dropOff {
          id
          location {
            id
            externalReference
            company
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            owned
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            serviceTime
            timeWindows {
              weekday
              from
              to
            }
            timezone
            loadingRequirements
            timeWindowType
          }
          timeWindow {
            id
            start
            end
          }
        }
        loadingMillimeter
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        pallets
        weight
        customerReference
        content
        transportRequirements
        stackable
        articleNumber
        articleName
        articleQuantity
        orderReference
        additionalInfo
      }
      startLocation {
        id
        externalReference
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        owned
        address {
          street
          zipCode
          city
          country
          coordinates {
            latitude
            longitude
          }
          comments
          region
        }
        serviceTime
        timeWindows {
          weekday
          from
          to
        }
        timezone
        loadingRequirements
        timeWindowType
      }
      depotLocation {
        id
        externalReference
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        owned
        address {
          street
          zipCode
          city
          country
          coordinates {
            latitude
            longitude
          }
          comments
          region
        }
        serviceTime
        timeWindows {
          weekday
          from
          to
        }
        timezone
        loadingRequirements
        timeWindowType
      }
    }
    messages {
      key
      type
      data
    }
  }
}
    `;
 const AssignUnplannedLoadsAsync_MutationDocument = gql`
    mutation assignUnplannedLoadsAsync_mutation($tourPlanId: String!, $settings: TourSettingsInput!, $loads: [TourPlannerLoadInput!]!) {
  assignUnplannedLoadsAsync(
    tourPlanId: $tourPlanId
    settings: $settings
    loads: $loads
  ) {
    tourPlan {
      id
      name
      tenantId
      planningDate
      vehicles {
        id
        name
        vehicleType
        maxLoadingWeight
        ldmm
        pallets
        vehicleCapabilities
        tours {
          id
          stops {
            id
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            reference
            earliestPlannedArrivalTime
            latestPlannedArrivalTime
            serviceTime
            loads {
              id
              pickUp {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              dropOff {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              loadingMillimeter
              article {
                id
                packagingOptions {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    parent {
                      packaging {
                        packagingCode
                        packagingDescription
                        articlesPerPackage
                        maxStackSize
                        dimensions {
                          weight
                          height
                          width
                          length
                        }
                        liftingSide
                      }
                      quantityChildrenPerParent
                    }
                    liftingSide
                  }
                  maxStackSize
                  articlesPerPackage
                }
                externalReference
                name
                weightInKgPerUnit
              }
              pallets
              weight
              customerReference
              content
              transportRequirements
              stackable
              articleNumber
              articleName
              articleQuantity
              orderReference
              additionalInfo
            }
            distance
          }
          distance
          route {
            sections {
              polyline
              summary {
                duration
                length
                consumption
                co2Emission
              }
              aggregateTolls {
                countryCode
                tollSystem
                currency
                value
              }
            }
          }
          shipment {
            id
            createdAt
          }
          lock {
            createdAt
            lockReason
          }
        }
      }
      fleets {
        id
        name
        fleetTemplateId
        bodyType
        fleetDimensions {
          totalLoadingWeight
          totalLoadingHeight
          totalLoadingWidth
          totalLoadingLength
          fleetCapabilities
        }
        carriers {
          id
          name
        }
        possibleLocationIds
        possibleCountries
        tours {
          id
          stops {
            id
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            reference
            earliestPlannedArrivalTime
            latestPlannedArrivalTime
            serviceTime
            loads {
              id
              pickUp {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              dropOff {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              loadingMillimeter
              article {
                id
                packagingOptions {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    parent {
                      packaging {
                        packagingCode
                        packagingDescription
                        articlesPerPackage
                        maxStackSize
                        dimensions {
                          weight
                          height
                          width
                          length
                        }
                        liftingSide
                      }
                      quantityChildrenPerParent
                    }
                    liftingSide
                  }
                  maxStackSize
                  articlesPerPackage
                }
                externalReference
                name
                weightInKgPerUnit
              }
              pallets
              weight
              customerReference
              content
              transportRequirements
              stackable
              articleNumber
              articleName
              articleQuantity
              orderReference
              additionalInfo
            }
            distance
          }
          distance
          route {
            sections {
              polyline
              summary {
                duration
                length
                consumption
                co2Emission
              }
              aggregateTolls {
                countryCode
                tollSystem
                currency
                value
              }
            }
          }
          shipment {
            id
            createdAt
          }
          lock {
            createdAt
            lockReason
          }
        }
      }
      configuration {
        maxDrivingHours
        maxWorkingHours
        cutOffTimeHours
        warningTimeHours
        toursAlwaysStartAtDepot
        toursAlwaysEndAtDepot
      }
      lastPlannedTourExecutionTime
      lockedAtTime
      lockedTimeout
      lock {
        createdAt
        timeout
        reason
      }
      unplannedLoads {
        id
        pickUp {
          id
          location {
            id
            externalReference
            company
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            owned
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            serviceTime
            timeWindows {
              weekday
              from
              to
            }
            timezone
            loadingRequirements
            timeWindowType
          }
          timeWindow {
            id
            start
            end
          }
        }
        dropOff {
          id
          location {
            id
            externalReference
            company
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            owned
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            serviceTime
            timeWindows {
              weekday
              from
              to
            }
            timezone
            loadingRequirements
            timeWindowType
          }
          timeWindow {
            id
            start
            end
          }
        }
        loadingMillimeter
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        pallets
        weight
        customerReference
        content
        transportRequirements
        stackable
        articleNumber
        articleName
        articleQuantity
        orderReference
        additionalInfo
      }
      startLocation {
        id
        externalReference
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        owned
        address {
          street
          zipCode
          city
          country
          coordinates {
            latitude
            longitude
          }
          comments
          region
        }
        serviceTime
        timeWindows {
          weekday
          from
          to
        }
        timezone
        loadingRequirements
        timeWindowType
      }
      depotLocation {
        id
        externalReference
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        owned
        address {
          street
          zipCode
          city
          country
          coordinates {
            latitude
            longitude
          }
          comments
          region
        }
        serviceTime
        timeWindows {
          weekday
          from
          to
        }
        timezone
        loadingRequirements
        timeWindowType
      }
    }
    messages {
      key
      type
      data
    }
  }
}
    `;
 const BulkLockTours_MutationDocument = gql`
    mutation bulkLockTours_mutation($tourPlanId: String!, $tourIds: [String!]!, $lockReason: TourLockReasonEnum!) {
  bulkLockTours(
    tourPlanId: $tourPlanId
    tourIds: $tourIds
    lockReason: $lockReason
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const CancelPlanning_MutationDocument = gql`
    mutation cancelPlanning_mutation($tourPlanId: String!) {
  cancelPlanning(tourPlanId: $tourPlanId) {
    tourPlan {
      id
      name
      tenantId
      planningDate
      vehicles {
        id
        name
        vehicleType
        maxLoadingWeight
        ldmm
        pallets
        vehicleCapabilities
        tours {
          id
          stops {
            id
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            reference
            earliestPlannedArrivalTime
            latestPlannedArrivalTime
            serviceTime
            loads {
              id
              pickUp {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              dropOff {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              loadingMillimeter
              article {
                id
                packagingOptions {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    parent {
                      packaging {
                        packagingCode
                        packagingDescription
                        articlesPerPackage
                        maxStackSize
                        dimensions {
                          weight
                          height
                          width
                          length
                        }
                        liftingSide
                      }
                      quantityChildrenPerParent
                    }
                    liftingSide
                  }
                  maxStackSize
                  articlesPerPackage
                }
                externalReference
                name
                weightInKgPerUnit
              }
              pallets
              weight
              customerReference
              content
              transportRequirements
              stackable
              articleNumber
              articleName
              articleQuantity
              orderReference
              additionalInfo
            }
            distance
          }
          distance
          route {
            sections {
              polyline
              summary {
                duration
                length
                consumption
                co2Emission
              }
              aggregateTolls {
                countryCode
                tollSystem
                currency
                value
              }
            }
          }
          shipment {
            id
            createdAt
          }
          lock {
            createdAt
            lockReason
          }
        }
      }
      fleets {
        id
        name
        fleetTemplateId
        bodyType
        fleetDimensions {
          totalLoadingWeight
          totalLoadingHeight
          totalLoadingWidth
          totalLoadingLength
          fleetCapabilities
        }
        carriers {
          id
          name
        }
        possibleLocationIds
        possibleCountries
        tours {
          id
          stops {
            id
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            reference
            earliestPlannedArrivalTime
            latestPlannedArrivalTime
            serviceTime
            loads {
              id
              pickUp {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              dropOff {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              loadingMillimeter
              article {
                id
                packagingOptions {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    parent {
                      packaging {
                        packagingCode
                        packagingDescription
                        articlesPerPackage
                        maxStackSize
                        dimensions {
                          weight
                          height
                          width
                          length
                        }
                        liftingSide
                      }
                      quantityChildrenPerParent
                    }
                    liftingSide
                  }
                  maxStackSize
                  articlesPerPackage
                }
                externalReference
                name
                weightInKgPerUnit
              }
              pallets
              weight
              customerReference
              content
              transportRequirements
              stackable
              articleNumber
              articleName
              articleQuantity
              orderReference
              additionalInfo
            }
            distance
          }
          distance
          route {
            sections {
              polyline
              summary {
                duration
                length
                consumption
                co2Emission
              }
              aggregateTolls {
                countryCode
                tollSystem
                currency
                value
              }
            }
          }
          shipment {
            id
            createdAt
          }
          lock {
            createdAt
            lockReason
          }
        }
      }
      configuration {
        maxDrivingHours
        maxWorkingHours
        cutOffTimeHours
        warningTimeHours
        toursAlwaysStartAtDepot
        toursAlwaysEndAtDepot
      }
      lastPlannedTourExecutionTime
      lockedAtTime
      lockedTimeout
      lock {
        createdAt
        timeout
        reason
      }
      unplannedLoads {
        id
        pickUp {
          id
          location {
            id
            externalReference
            company
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            owned
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            serviceTime
            timeWindows {
              weekday
              from
              to
            }
            timezone
            loadingRequirements
            timeWindowType
          }
          timeWindow {
            id
            start
            end
          }
        }
        dropOff {
          id
          location {
            id
            externalReference
            company
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            owned
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            serviceTime
            timeWindows {
              weekday
              from
              to
            }
            timezone
            loadingRequirements
            timeWindowType
          }
          timeWindow {
            id
            start
            end
          }
        }
        loadingMillimeter
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        pallets
        weight
        customerReference
        content
        transportRequirements
        stackable
        articleNumber
        articleName
        articleQuantity
        orderReference
        additionalInfo
      }
      startLocation {
        id
        externalReference
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        owned
        address {
          street
          zipCode
          city
          country
          coordinates {
            latitude
            longitude
          }
          comments
          region
        }
        serviceTime
        timeWindows {
          weekday
          from
          to
        }
        timezone
        loadingRequirements
        timeWindowType
      }
      depotLocation {
        id
        externalReference
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        owned
        address {
          street
          zipCode
          city
          country
          coordinates {
            latitude
            longitude
          }
          comments
          region
        }
        serviceTime
        timeWindows {
          weekday
          from
          to
        }
        timezone
        loadingRequirements
        timeWindowType
      }
    }
    messages {
      key
      type
      data
    }
  }
}
    `;
 const CreateTourPlan_MutationDocument = gql`
    mutation createTourPlan_mutation($name: String!, $planningDate: String!, $vehicles: [TourPlannerVehicleInput!]!, $fleets: [TourPlannerFleetInput!]!, $depotLocation: TourPlannerLocationInput) {
  createTourPlan(
    name: $name
    planningDate: $planningDate
    vehicles: $vehicles
    fleets: $fleets
    depotLocation: $depotLocation
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const FindLoadsUsedInTourPlan_QueryDocument = gql`
    query findLoadsUsedInTourPlan_query($loadIds: [String!]!) {
  findLoadsUsedInTourPlan(loadIds: $loadIds) {
    alreadyAssignedLoadIds
    lockedIds
  }
}
    `;
 const GetTourPlannerConfiguration_QueryDocument = gql`
    query getTourPlannerConfiguration_query {
  getTourPlannerConfiguration {
    maxDrivingHours
    maxWorkingHours
    cutOffTimeHours
    warningTimeHours
    toursAlwaysStartAtDepot
    toursAlwaysEndAtDepot
  }
}
    `;
 const LockTour_MutationDocument = gql`
    mutation lockTour_mutation($tourPlanId: String!, $tourId: String!, $lockReason: TourLockReasonEnum!) {
  lockTour(tourPlanId: $tourPlanId, tourId: $tourId, lockReason: $lockReason) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const MoveFleetsFromDateToTourPlan_MutationDocument = gql`
    mutation moveFleetsFromDateToTourPlan_mutation($tourPlanId: String!, $fromDate: String!) {
  moveFleetsFromDateToTourPlan(tourPlanId: $tourPlanId, fromDate: $fromDate) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const MoveLoadToFleet_MutationDocument = gql`
    mutation moveLoadToFleet_mutation($tourPlanId: String!, $fleetId: String!, $loadId: String!) {
  moveLoadToFleet(tourPlanId: $tourPlanId, fleetId: $fleetId, loadId: $loadId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const MoveLoadToStop_MutationDocument = gql`
    mutation moveLoadToStop_mutation($tourPlanId: String!, $fromStopId: String!, $toStopId: String!, $loadId: String!) {
  moveLoadToStop(
    tourPlanId: $tourPlanId
    fromStopId: $fromStopId
    toStopId: $toStopId
    loadId: $loadId
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const MoveLoadToTour_MutationDocument = gql`
    mutation moveLoadToTour_mutation($tourPlanId: String!, $tourId: String!, $loadId: String!, $index: Int) {
  moveLoadToTour(
    tourPlanId: $tourPlanId
    tourId: $tourId
    loadId: $loadId
    index: $index
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const MoveLoadToVehicle_MutationDocument = gql`
    mutation moveLoadToVehicle_mutation($tourPlanId: String!, $vehicleId: String!, $loadId: String!) {
  moveLoadToVehicle(
    tourPlanId: $tourPlanId
    vehicleId: $vehicleId
    loadId: $loadId
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const MoveStopToFleet_MutationDocument = gql`
    mutation moveStopToFleet_mutation($tourPlanId: String!, $stopId: String!, $fleetId: String!) {
  moveStopToFleet(tourPlanId: $tourPlanId, stopId: $stopId, fleetId: $fleetId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const MoveStopToTour_MutationDocument = gql`
    mutation moveStopToTour_mutation($tourPlanId: String!, $stopId: String!, $tourId: String!, $index: Int) {
  moveStopToTour(
    tourPlanId: $tourPlanId
    stopId: $stopId
    tourId: $tourId
    index: $index
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const MoveTourToFleet_MutationDocument = gql`
    mutation moveTourToFleet_mutation($tourPlanId: String!, $tourId: String!, $fleetId: String!, $index: Int) {
  moveTourToFleet(
    tourPlanId: $tourPlanId
    tourId: $tourId
    fleetId: $fleetId
    index: $index
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const OptimizeFleet_MutationDocument = gql`
    mutation optimizeFleet_mutation($tourPlanId: String!, $fleetId: String!, $tourId: String!) {
  optimizeFleet(tourPlanId: $tourPlanId, fleetId: $fleetId, tourId: $tourId) {
    tourPlan {
      id
      name
      tenantId
      planningDate
      vehicles {
        id
        name
        vehicleType
        maxLoadingWeight
        ldmm
        pallets
        vehicleCapabilities
        tours {
          id
          stops {
            id
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            reference
            earliestPlannedArrivalTime
            latestPlannedArrivalTime
            serviceTime
            loads {
              id
              pickUp {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              dropOff {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              loadingMillimeter
              article {
                id
                packagingOptions {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    parent {
                      packaging {
                        packagingCode
                        packagingDescription
                        articlesPerPackage
                        maxStackSize
                        dimensions {
                          weight
                          height
                          width
                          length
                        }
                        liftingSide
                      }
                      quantityChildrenPerParent
                    }
                    liftingSide
                  }
                  maxStackSize
                  articlesPerPackage
                }
                externalReference
                name
                weightInKgPerUnit
              }
              pallets
              weight
              customerReference
              content
              transportRequirements
              stackable
              articleNumber
              articleName
              articleQuantity
              orderReference
              additionalInfo
            }
            distance
          }
          distance
          route {
            sections {
              polyline
              summary {
                duration
                length
                consumption
                co2Emission
              }
              aggregateTolls {
                countryCode
                tollSystem
                currency
                value
              }
            }
          }
          shipment {
            id
            createdAt
          }
          lock {
            createdAt
            lockReason
          }
        }
      }
      fleets {
        id
        name
        fleetTemplateId
        bodyType
        fleetDimensions {
          totalLoadingWeight
          totalLoadingHeight
          totalLoadingWidth
          totalLoadingLength
          fleetCapabilities
        }
        carriers {
          id
          name
        }
        possibleLocationIds
        possibleCountries
        tours {
          id
          stops {
            id
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            reference
            earliestPlannedArrivalTime
            latestPlannedArrivalTime
            serviceTime
            loads {
              id
              pickUp {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              dropOff {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              loadingMillimeter
              article {
                id
                packagingOptions {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    parent {
                      packaging {
                        packagingCode
                        packagingDescription
                        articlesPerPackage
                        maxStackSize
                        dimensions {
                          weight
                          height
                          width
                          length
                        }
                        liftingSide
                      }
                      quantityChildrenPerParent
                    }
                    liftingSide
                  }
                  maxStackSize
                  articlesPerPackage
                }
                externalReference
                name
                weightInKgPerUnit
              }
              pallets
              weight
              customerReference
              content
              transportRequirements
              stackable
              articleNumber
              articleName
              articleQuantity
              orderReference
              additionalInfo
            }
            distance
          }
          distance
          route {
            sections {
              polyline
              summary {
                duration
                length
                consumption
                co2Emission
              }
              aggregateTolls {
                countryCode
                tollSystem
                currency
                value
              }
            }
          }
          shipment {
            id
            createdAt
          }
          lock {
            createdAt
            lockReason
          }
        }
      }
      configuration {
        maxDrivingHours
        maxWorkingHours
        cutOffTimeHours
        warningTimeHours
        toursAlwaysStartAtDepot
        toursAlwaysEndAtDepot
      }
      lastPlannedTourExecutionTime
      lockedAtTime
      lockedTimeout
      lock {
        createdAt
        timeout
        reason
      }
      unplannedLoads {
        id
        pickUp {
          id
          location {
            id
            externalReference
            company
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            owned
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            serviceTime
            timeWindows {
              weekday
              from
              to
            }
            timezone
            loadingRequirements
            timeWindowType
          }
          timeWindow {
            id
            start
            end
          }
        }
        dropOff {
          id
          location {
            id
            externalReference
            company
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            owned
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            serviceTime
            timeWindows {
              weekday
              from
              to
            }
            timezone
            loadingRequirements
            timeWindowType
          }
          timeWindow {
            id
            start
            end
          }
        }
        loadingMillimeter
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        pallets
        weight
        customerReference
        content
        transportRequirements
        stackable
        articleNumber
        articleName
        articleQuantity
        orderReference
        additionalInfo
      }
      startLocation {
        id
        externalReference
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        owned
        address {
          street
          zipCode
          city
          country
          coordinates {
            latitude
            longitude
          }
          comments
          region
        }
        serviceTime
        timeWindows {
          weekday
          from
          to
        }
        timezone
        loadingRequirements
        timeWindowType
      }
      depotLocation {
        id
        externalReference
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        owned
        address {
          street
          zipCode
          city
          country
          coordinates {
            latitude
            longitude
          }
          comments
          region
        }
        serviceTime
        timeWindows {
          weekday
          from
          to
        }
        timezone
        loadingRequirements
        timeWindowType
      }
    }
    messages {
      key
      type
      data
    }
  }
}
    `;
 const RemoveFleetsFromTourPlan_MutationDocument = gql`
    mutation removeFleetsFromTourPlan_mutation($tourPlanId: String!, $fleetIds: [String!]!) {
  removeFleetsFromTourPlan(tourPlanId: $tourPlanId, fleetIds: $fleetIds) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const RemoveLoadFromTourPlan_MutationDocument = gql`
    mutation removeLoadFromTourPlan_mutation($tourPlanId: String!, $loadId: String!) {
  removeLoadFromTourPlan(tourPlanId: $tourPlanId, loadId: $loadId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const RemoveStopFromTourPlan_MutationDocument = gql`
    mutation removeStopFromTourPlan_mutation($tourPlanId: String!, $stopId: String!) {
  removeStopFromTourPlan(tourPlanId: $tourPlanId, stopId: $stopId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const RemoveTourFromTourPlan_MutationDocument = gql`
    mutation removeTourFromTourPlan_mutation($tourPlanId: String!, $tourId: String!) {
  removeTourFromTourPlan(tourPlanId: $tourPlanId, tourId: $tourId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const ReverseTour_MutationDocument = gql`
    mutation reverseTour_mutation($tourPlanId: String!, $tourId: String!) {
  reverseTour(tourPlanId: $tourPlanId, tourId: $tourId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const SendTourToShipmentExecution_MutationDocument = gql`
    mutation sendTourToShipmentExecution_mutation($tourPlanId: String!, $tourId: String!, $lockReason: TourLockReasonEnum!) {
  sendTourToShipmentExecution(
    tourPlanId: $tourPlanId
    tourId: $tourId
    lockReason: $lockReason
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const TourPlanById_QueryDocument = gql`
    query tourPlanById_query($id: String!) {
  tourPlanById(id: $id) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const TourPlanByName_QueryDocument = gql`
    query tourPlanByName_query($name: String!) {
  tourPlanByName(name: $name) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const TourPlanScore_QueryDocument = gql`
    query tourPlanScore_query($tourPlan: TourPlannerTourPlanInput!, $depotLocationId: String!) {
  tourPlanScore(tourPlan: $tourPlan, depotLocationId: $depotLocationId)
}
    `;
 const TourPlansByDate_QueryDocument = gql`
    query tourPlansByDate_query($date: DateTime!) {
  tourPlansByDate(date: $date) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const TourPlansByDateAggregated_QueryDocument = gql`
    query tourPlansByDateAggregated_query($fromDate: DateTime!, $toDate: DateTime) {
  tourPlansByDateAggregated(fromDate: $fromDate, toDate: $toDate) {
    id
    date
    locations {
      id
      locationId
      finalizedLoads
      plannedLoads
      finalizedTours
      plannedTours
    }
  }
}
    `;
 const UnlockTour_MutationDocument = gql`
    mutation unlockTour_mutation($tourPlanId: String!, $tourId: String!) {
  unlockTour(tourPlanId: $tourPlanId, tourId: $tourId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
 const UpdateTourPlannerConfiguration_MutationDocument = gql`
    mutation updateTourPlannerConfiguration_mutation($configuration: TourPlannerConfigurationInput!) {
  updateTourPlannerConfiguration(configuration: $configuration) {
    maxDrivingHours
    maxWorkingHours
    cutOffTimeHours
    warningTimeHours
    toursAlwaysStartAtDepot
    toursAlwaysEndAtDepot
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    addEquipmentCharge_mutation(variables: Types.AddEquipmentCharge_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.AddEquipmentCharge_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AddEquipmentCharge_Mutation>(AddEquipmentCharge_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addEquipmentCharge_mutation', 'mutation', variables);
    },
    addRateLaneBased_mutation(variables: Types.AddRateLaneBased_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.AddRateLaneBased_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AddRateLaneBased_Mutation>(AddRateLaneBased_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addRateLaneBased_mutation', 'mutation', variables);
    },
    createCarrier_mutation(variables: Types.CreateCarrier_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreateCarrier_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateCarrier_Mutation>(CreateCarrier_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCarrier_mutation', 'mutation', variables);
    },
    createDispatcher_mutation(variables: Types.CreateDispatcher_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreateDispatcher_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateDispatcher_Mutation>(CreateDispatcher_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createDispatcher_mutation', 'mutation', variables);
    },
    createFleet_mutation(variables: Types.CreateFleet_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreateFleet_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateFleet_Mutation>(CreateFleet_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createFleet_mutation', 'mutation', variables);
    },
    createVehicle_mutation(variables: Types.CreateVehicle_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreateVehicle_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateVehicle_Mutation>(CreateVehicle_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createVehicle_mutation', 'mutation', variables);
    },
    createVehicles_mutation(variables: Types.CreateVehicles_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreateVehicles_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateVehicles_Mutation>(CreateVehicles_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createVehicles_mutation', 'mutation', variables);
    },
    deleteCarrier_mutation(variables: Types.DeleteCarrier_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteCarrier_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteCarrier_Mutation>(DeleteCarrier_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteCarrier_mutation', 'mutation', variables);
    },
    deleteDispatchers_mutation(variables: Types.DeleteDispatchers_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteDispatchers_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteDispatchers_Mutation>(DeleteDispatchers_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteDispatchers_mutation', 'mutation', variables);
    },
    deleteEquipmentCharges_mutation(variables: Types.DeleteEquipmentCharges_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteEquipmentCharges_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteEquipmentCharges_Mutation>(DeleteEquipmentCharges_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteEquipmentCharges_mutation', 'mutation', variables);
    },
    deleteFleet_mutation(variables: Types.DeleteFleet_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteFleet_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteFleet_Mutation>(DeleteFleet_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteFleet_mutation', 'mutation', variables);
    },
    deleteFleets_mutation(variables: Types.DeleteFleets_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteFleets_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteFleets_Mutation>(DeleteFleets_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteFleets_mutation', 'mutation', variables);
    },
    deleteVehicle_mutation(variables: Types.DeleteVehicle_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteVehicle_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteVehicle_Mutation>(DeleteVehicle_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteVehicle_mutation', 'mutation', variables);
    },
    deleteVehicles_mutation(variables: Types.DeleteVehicles_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteVehicles_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteVehicles_Mutation>(DeleteVehicles_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteVehicles_mutation', 'mutation', variables);
    },
    disableCarrier_mutation(variables: Types.DisableCarrier_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DisableCarrier_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DisableCarrier_Mutation>(DisableCarrier_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'disableCarrier_mutation', 'mutation', variables);
    },
    enableCarrier_mutation(variables: Types.EnableCarrier_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.EnableCarrier_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.EnableCarrier_Mutation>(EnableCarrier_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'enableCarrier_mutation', 'mutation', variables);
    },
    findCarrier_query(variables: Types.FindCarrier_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindCarrier_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindCarrier_Query>(FindCarrier_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findCarrier_query', 'query', variables);
    },
    findCarriers_query(variables: Types.FindCarriers_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindCarriers_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindCarriers_Query>(FindCarriers_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findCarriers_query', 'query', variables);
    },
    findFleets_query(variables: Types.FindFleets_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindFleets_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindFleets_Query>(FindFleets_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findFleets_query', 'query', variables);
    },
    findVehicle_query(variables: Types.FindVehicle_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindVehicle_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindVehicle_Query>(FindVehicle_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findVehicle_query', 'query', variables);
    },
    findVehicles_query(variables: Types.FindVehicles_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindVehicles_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindVehicles_Query>(FindVehicles_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findVehicles_query', 'query', variables);
    },
    findVehiclesByExternalReferences_query(variables: Types.FindVehiclesByExternalReferences_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindVehiclesByExternalReferences_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindVehiclesByExternalReferences_Query>(FindVehiclesByExternalReferences_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findVehiclesByExternalReferences_query', 'query', variables);
    },
    importCarriers_mutation(variables: Types.ImportCarriers_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.ImportCarriers_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ImportCarriers_Mutation>(ImportCarriers_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'importCarriers_mutation', 'mutation', variables);
    },
    importRateLaneBased_mutation(variables: Types.ImportRateLaneBased_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.ImportRateLaneBased_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ImportRateLaneBased_Mutation>(ImportRateLaneBased_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'importRateLaneBased_mutation', 'mutation', variables);
    },
    ratesLookup_query(variables: Types.RatesLookup_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.RatesLookup_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RatesLookup_Query>(RatesLookup_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ratesLookup_query', 'query', variables);
    },
    removeRateLaneBased_mutation(variables: Types.RemoveRateLaneBased_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.RemoveRateLaneBased_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RemoveRateLaneBased_Mutation>(RemoveRateLaneBased_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeRateLaneBased_mutation', 'mutation', variables);
    },
    seedVehiclesE2E_mutation(variables?: Types.SeedVehiclesE2E_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SeedVehiclesE2E_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SeedVehiclesE2E_Mutation>(SeedVehiclesE2E_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'seedVehiclesE2E_mutation', 'mutation', variables);
    },
    updateCarrier_mutation(variables: Types.UpdateCarrier_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateCarrier_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateCarrier_Mutation>(UpdateCarrier_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCarrier_mutation', 'mutation', variables);
    },
    updateDispatcher_mutation(variables: Types.UpdateDispatcher_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateDispatcher_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateDispatcher_Mutation>(UpdateDispatcher_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDispatcher_mutation', 'mutation', variables);
    },
    updateEquipmentCharge_mutation(variables: Types.UpdateEquipmentCharge_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateEquipmentCharge_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateEquipmentCharge_Mutation>(UpdateEquipmentCharge_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateEquipmentCharge_mutation', 'mutation', variables);
    },
    updateFleet_mutation(variables: Types.UpdateFleet_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateFleet_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateFleet_Mutation>(UpdateFleet_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateFleet_mutation', 'mutation', variables);
    },
    updateRateLaneBased_mutation(variables: Types.UpdateRateLaneBased_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateRateLaneBased_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateRateLaneBased_Mutation>(UpdateRateLaneBased_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateRateLaneBased_mutation', 'mutation', variables);
    },
    updateRatePerKm_mutation(variables: Types.UpdateRatePerKm_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateRatePerKm_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateRatePerKm_Mutation>(UpdateRatePerKm_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateRatePerKm_mutation', 'mutation', variables);
    },
    updateUnloadingCharges_mutation(variables: Types.UpdateUnloadingCharges_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateUnloadingCharges_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateUnloadingCharges_Mutation>(UpdateUnloadingCharges_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUnloadingCharges_mutation', 'mutation', variables);
    },
    updateVehicle_mutation(variables: Types.UpdateVehicle_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateVehicle_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateVehicle_Mutation>(UpdateVehicle_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVehicle_mutation', 'mutation', variables);
    },
    createArticle_mutation(variables: Types.CreateArticle_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreateArticle_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateArticle_Mutation>(CreateArticle_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createArticle_mutation', 'mutation', variables);
    },
    createArticles_mutation(variables: Types.CreateArticles_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreateArticles_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateArticles_Mutation>(CreateArticles_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createArticles_mutation', 'mutation', variables);
    },
    createLoadV2_mutation(variables: Types.CreateLoadV2_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreateLoadV2_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateLoadV2_Mutation>(CreateLoadV2_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createLoadV2_mutation', 'mutation', variables);
    },
    createLoadsV2_mutation(variables: Types.CreateLoadsV2_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreateLoadsV2_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateLoadsV2_Mutation>(CreateLoadsV2_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createLoadsV2_mutation', 'mutation', variables);
    },
    createLocationV2_mutation(variables: Types.CreateLocationV2_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreateLocationV2_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateLocationV2_Mutation>(CreateLocationV2_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createLocationV2_mutation', 'mutation', variables);
    },
    createLocationsV2_mutation(variables: Types.CreateLocationsV2_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreateLocationsV2_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateLocationsV2_Mutation>(CreateLocationsV2_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createLocationsV2_mutation', 'mutation', variables);
    },
    createOrder_mutation(variables: Types.CreateOrder_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreateOrder_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateOrder_Mutation>(CreateOrder_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrder_mutation', 'mutation', variables);
    },
    createOrders_mutation(variables: Types.CreateOrders_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreateOrders_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateOrders_Mutation>(CreateOrders_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrders_mutation', 'mutation', variables);
    },
    createPackaging_mutation(variables: Types.CreatePackaging_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreatePackaging_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreatePackaging_Mutation>(CreatePackaging_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPackaging_mutation', 'mutation', variables);
    },
    deleteArticle_mutation(variables: Types.DeleteArticle_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteArticle_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteArticle_Mutation>(DeleteArticle_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteArticle_mutation', 'mutation', variables);
    },
    deleteArticles_mutation(variables: Types.DeleteArticles_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteArticles_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteArticles_Mutation>(DeleteArticles_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteArticles_mutation', 'mutation', variables);
    },
    deleteLoadV2_mutation(variables: Types.DeleteLoadV2_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteLoadV2_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteLoadV2_Mutation>(DeleteLoadV2_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteLoadV2_mutation', 'mutation', variables);
    },
    deleteLoadsV2_mutation(variables: Types.DeleteLoadsV2_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteLoadsV2_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteLoadsV2_Mutation>(DeleteLoadsV2_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteLoadsV2_mutation', 'mutation', variables);
    },
    deleteLocationV2_mutation(variables: Types.DeleteLocationV2_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteLocationV2_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteLocationV2_Mutation>(DeleteLocationV2_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteLocationV2_mutation', 'mutation', variables);
    },
    deleteLocationsV2_mutation(variables: Types.DeleteLocationsV2_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteLocationsV2_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteLocationsV2_Mutation>(DeleteLocationsV2_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteLocationsV2_mutation', 'mutation', variables);
    },
    deleteOrder_mutation(variables: Types.DeleteOrder_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteOrder_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteOrder_Mutation>(DeleteOrder_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteOrder_mutation', 'mutation', variables);
    },
    deleteOrders_mutation(variables: Types.DeleteOrders_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteOrders_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteOrders_Mutation>(DeleteOrders_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteOrders_mutation', 'mutation', variables);
    },
    estimateTravelDuration_query(variables: Types.EstimateTravelDuration_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.EstimateTravelDuration_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.EstimateTravelDuration_Query>(EstimateTravelDuration_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'estimateTravelDuration_query', 'query', variables);
    },
    findArticle_query(variables: Types.FindArticle_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindArticle_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindArticle_Query>(FindArticle_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findArticle_query', 'query', variables);
    },
    findArticles_query(variables: Types.FindArticles_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindArticles_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindArticles_Query>(FindArticles_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findArticles_query', 'query', variables);
    },
    findArticlesByExternalReferences_query(variables: Types.FindArticlesByExternalReferences_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindArticlesByExternalReferences_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindArticlesByExternalReferences_Query>(FindArticlesByExternalReferences_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findArticlesByExternalReferences_query', 'query', variables);
    },
    findLoadCountsByDepots_query(variables: Types.FindLoadCountsByDepots_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindLoadCountsByDepots_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindLoadCountsByDepots_Query>(FindLoadCountsByDepots_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findLoadCountsByDepots_query', 'query', variables);
    },
    findLoadV2_query(variables: Types.FindLoadV2_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindLoadV2_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindLoadV2_Query>(FindLoadV2_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findLoadV2_query', 'query', variables);
    },
    findLoadsByExternalReferencesV2_query(variables: Types.FindLoadsByExternalReferencesV2_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindLoadsByExternalReferencesV2_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindLoadsByExternalReferencesV2_Query>(FindLoadsByExternalReferencesV2_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findLoadsByExternalReferencesV2_query', 'query', variables);
    },
    findLoadsCount_query(variables: Types.FindLoadsCount_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindLoadsCount_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindLoadsCount_Query>(FindLoadsCount_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findLoadsCount_query', 'query', variables);
    },
    findLoadsV2_query(variables: Types.FindLoadsV2_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindLoadsV2_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindLoadsV2_Query>(FindLoadsV2_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findLoadsV2_query', 'query', variables);
    },
    findLocationV2_query(variables: Types.FindLocationV2_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindLocationV2_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindLocationV2_Query>(FindLocationV2_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findLocationV2_query', 'query', variables);
    },
    findLocationsByExternalReferencesV2_query(variables: Types.FindLocationsByExternalReferencesV2_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindLocationsByExternalReferencesV2_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindLocationsByExternalReferencesV2_Query>(FindLocationsByExternalReferencesV2_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findLocationsByExternalReferencesV2_query', 'query', variables);
    },
    findLocationsV2_query(variables: Types.FindLocationsV2_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindLocationsV2_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindLocationsV2_Query>(FindLocationsV2_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findLocationsV2_query', 'query', variables);
    },
    findOrder_query(variables: Types.FindOrder_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindOrder_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindOrder_Query>(FindOrder_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findOrder_query', 'query', variables);
    },
    findOrders_query(variables: Types.FindOrders_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindOrders_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindOrders_Query>(FindOrders_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findOrders_query', 'query', variables);
    },
    findOrdersByExternalReferences_query(variables: Types.FindOrdersByExternalReferences_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindOrdersByExternalReferences_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindOrdersByExternalReferences_Query>(FindOrdersByExternalReferences_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findOrdersByExternalReferences_query', 'query', variables);
    },
    findPackages_query(variables: Types.FindPackages_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindPackages_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindPackages_Query>(FindPackages_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findPackages_query', 'query', variables);
    },
    getLocationMasterDataInfo_query(variables: Types.GetLocationMasterDataInfo_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.GetLocationMasterDataInfo_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetLocationMasterDataInfo_Query>(GetLocationMasterDataInfo_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getLocationMasterDataInfo_query', 'query', variables);
    },
    importArticles_mutation(variables: Types.ImportArticles_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.ImportArticles_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ImportArticles_Mutation>(ImportArticles_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'importArticles_mutation', 'mutation', variables);
    },
    importLoadLocations_mutation(variables: Types.ImportLoadLocations_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.ImportLoadLocations_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ImportLoadLocations_Mutation>(ImportLoadLocations_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'importLoadLocations_mutation', 'mutation', variables);
    },
    importLoadsV2_mutation(variables: Types.ImportLoadsV2_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.ImportLoadsV2_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ImportLoadsV2_Mutation>(ImportLoadsV2_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'importLoadsV2_mutation', 'mutation', variables);
    },
    importLocationsV2_mutation(variables: Types.ImportLocationsV2_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.ImportLocationsV2_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ImportLocationsV2_Mutation>(ImportLocationsV2_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'importLocationsV2_mutation', 'mutation', variables);
    },
    importOrders_mutation(variables: Types.ImportOrders_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.ImportOrders_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ImportOrders_Mutation>(ImportOrders_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'importOrders_mutation', 'mutation', variables);
    },
    importPackaging_mutation(variables: Types.ImportPackaging_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.ImportPackaging_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ImportPackaging_Mutation>(ImportPackaging_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'importPackaging_mutation', 'mutation', variables);
    },
    matchOrder_mutation(variables: Types.MatchOrder_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.MatchOrder_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.MatchOrder_Mutation>(MatchOrder_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matchOrder_mutation', 'mutation', variables);
    },
    seedLoads_mutation(variables?: Types.SeedLoads_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SeedLoads_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SeedLoads_Mutation>(SeedLoads_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'seedLoads_mutation', 'mutation', variables);
    },
    seedLocations_mutation(variables?: Types.SeedLocations_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SeedLocations_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SeedLocations_Mutation>(SeedLocations_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'seedLocations_mutation', 'mutation', variables);
    },
    unmatchOrder_mutation(variables: Types.UnmatchOrder_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UnmatchOrder_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UnmatchOrder_Mutation>(UnmatchOrder_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unmatchOrder_mutation', 'mutation', variables);
    },
    updateArticle_mutation(variables: Types.UpdateArticle_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateArticle_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateArticle_Mutation>(UpdateArticle_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateArticle_mutation', 'mutation', variables);
    },
    updateLoadV2_mutation(variables: Types.UpdateLoadV2_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateLoadV2_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateLoadV2_Mutation>(UpdateLoadV2_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateLoadV2_mutation', 'mutation', variables);
    },
    updateLocationV2_mutation(variables: Types.UpdateLocationV2_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateLocationV2_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateLocationV2_Mutation>(UpdateLocationV2_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateLocationV2_mutation', 'mutation', variables);
    },
    updateOrder_mutation(variables: Types.UpdateOrder_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateOrder_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateOrder_Mutation>(UpdateOrder_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrder_mutation', 'mutation', variables);
    },
    createOrderPlanningVehicle_mutation(variables: Types.CreateOrderPlanningVehicle_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreateOrderPlanningVehicle_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateOrderPlanningVehicle_Mutation>(CreateOrderPlanningVehicle_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrderPlanningVehicle_mutation', 'mutation', variables);
    },
    deleteOrderPlanningVehicle_mutation(variables: Types.DeleteOrderPlanningVehicle_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteOrderPlanningVehicle_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteOrderPlanningVehicle_Mutation>(DeleteOrderPlanningVehicle_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteOrderPlanningVehicle_mutation', 'mutation', variables);
    },
    findOrderPlanningVehicle_query(variables: Types.FindOrderPlanningVehicle_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindOrderPlanningVehicle_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindOrderPlanningVehicle_Query>(FindOrderPlanningVehicle_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findOrderPlanningVehicle_query', 'query', variables);
    },
    findOrderPlanningVehicles_query(variables: Types.FindOrderPlanningVehicles_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindOrderPlanningVehicles_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindOrderPlanningVehicles_Query>(FindOrderPlanningVehicles_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findOrderPlanningVehicles_query', 'query', variables);
    },
    getOrderPlanningLoadsInfo_query(variables: Types.GetOrderPlanningLoadsInfo_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.GetOrderPlanningLoadsInfo_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetOrderPlanningLoadsInfo_Query>(GetOrderPlanningLoadsInfo_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrderPlanningLoadsInfo_query', 'query', variables);
    },
    updateOrderPlanningVehicle_mutation(variables: Types.UpdateOrderPlanningVehicle_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateOrderPlanningVehicle_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateOrderPlanningVehicle_Mutation>(UpdateOrderPlanningVehicle_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrderPlanningVehicle_mutation', 'mutation', variables);
    },
    bookCargoboardOrder_mutation(variables: Types.BookCargoboardOrder_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.BookCargoboardOrder_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.BookCargoboardOrder_Mutation>(BookCargoboardOrder_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bookCargoboardOrder_mutation', 'mutation', variables);
    },
    cancelCargoboardOrder_mutation(variables: Types.CancelCargoboardOrder_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CancelCargoboardOrder_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CancelCargoboardOrder_Mutation>(CancelCargoboardOrder_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cancelCargoboardOrder_mutation', 'mutation', variables);
    },
    countShipmentByStatus_query(variables: Types.CountShipmentByStatus_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CountShipmentByStatus_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CountShipmentByStatus_Query>(CountShipmentByStatus_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'countShipmentByStatus_query', 'query', variables);
    },
    createShipment_mutation(variables: Types.CreateShipment_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreateShipment_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateShipment_Mutation>(CreateShipment_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createShipment_mutation', 'mutation', variables);
    },
    deleteShipment_mutation(variables: Types.DeleteShipment_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteShipment_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteShipment_Mutation>(DeleteShipment_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteShipment_mutation', 'mutation', variables);
    },
    findCargoboardQuotation_query(variables: Types.FindCargoboardQuotation_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindCargoboardQuotation_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindCargoboardQuotation_Query>(FindCargoboardQuotation_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findCargoboardQuotation_query', 'query', variables);
    },
    findCustomerShipmentTracking_query(variables: Types.FindCustomerShipmentTracking_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindCustomerShipmentTracking_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindCustomerShipmentTracking_Query>(FindCustomerShipmentTracking_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findCustomerShipmentTracking_query', 'query', variables);
    },
    findShipment_query(variables: Types.FindShipment_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindShipment_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindShipment_Query>(FindShipment_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findShipment_query', 'query', variables);
    },
    findShipmentOrderRequest_query(variables: Types.FindShipmentOrderRequest_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindShipmentOrderRequest_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindShipmentOrderRequest_Query>(FindShipmentOrderRequest_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findShipmentOrderRequest_query', 'query', variables);
    },
    findShipments_query(variables: Types.FindShipments_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindShipments_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindShipments_Query>(FindShipments_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findShipments_query', 'query', variables);
    },
    loginWithApi_mutation(variables: Types.LoginWithApi_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.LoginWithApi_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.LoginWithApi_Mutation>(LoginWithApi_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'loginWithApi_mutation', 'mutation', variables);
    },
    registerCargoboardCompany_mutation(variables: Types.RegisterCargoboardCompany_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.RegisterCargoboardCompany_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RegisterCargoboardCompany_Mutation>(RegisterCargoboardCompany_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registerCargoboardCompany_mutation', 'mutation', variables);
    },
    reportIncident_mutation(variables: Types.ReportIncident_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.ReportIncident_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ReportIncident_Mutation>(ReportIncident_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reportIncident_mutation', 'mutation', variables);
    },
    setRequestAccepted_mutation(variables: Types.SetRequestAccepted_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SetRequestAccepted_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SetRequestAccepted_Mutation>(SetRequestAccepted_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setRequestAccepted_mutation', 'mutation', variables);
    },
    setShipmentStatusAllocatedDirectly_mutation(variables: Types.SetShipmentStatusAllocatedDirectly_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SetShipmentStatusAllocatedDirectly_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SetShipmentStatusAllocatedDirectly_Mutation>(SetShipmentStatusAllocatedDirectly_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setShipmentStatusAllocatedDirectly_mutation', 'mutation', variables);
    },
    setShipmentStatusCancelled_mutation(variables: Types.SetShipmentStatusCancelled_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SetShipmentStatusCancelled_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SetShipmentStatusCancelled_Mutation>(SetShipmentStatusCancelled_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setShipmentStatusCancelled_mutation', 'mutation', variables);
    },
    setShipmentStatusCompleted_mutation(variables: Types.SetShipmentStatusCompleted_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SetShipmentStatusCompleted_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SetShipmentStatusCompleted_Mutation>(SetShipmentStatusCompleted_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setShipmentStatusCompleted_mutation', 'mutation', variables);
    },
    setShipmentStatusCreated_mutation(variables: Types.SetShipmentStatusCreated_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SetShipmentStatusCreated_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SetShipmentStatusCreated_Mutation>(SetShipmentStatusCreated_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setShipmentStatusCreated_mutation', 'mutation', variables);
    },
    setShipmentStatusInTransit_mutation(variables: Types.SetShipmentStatusInTransit_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SetShipmentStatusInTransit_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SetShipmentStatusInTransit_Mutation>(SetShipmentStatusInTransit_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setShipmentStatusInTransit_mutation', 'mutation', variables);
    },
    setShipmentStatusRequestRevoked_mutation(variables: Types.SetShipmentStatusRequestRevoked_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SetShipmentStatusRequestRevoked_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SetShipmentStatusRequestRevoked_Mutation>(SetShipmentStatusRequestRevoked_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setShipmentStatusRequestRevoked_mutation', 'mutation', variables);
    },
    setShipmentStatusRequested_mutation(variables: Types.SetShipmentStatusRequested_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SetShipmentStatusRequested_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SetShipmentStatusRequested_Mutation>(SetShipmentStatusRequested_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setShipmentStatusRequested_mutation', 'mutation', variables);
    },
    setShipmentStopStatusCancelled_mutation(variables: Types.SetShipmentStopStatusCancelled_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SetShipmentStopStatusCancelled_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SetShipmentStopStatusCancelled_Mutation>(SetShipmentStopStatusCancelled_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setShipmentStopStatusCancelled_mutation', 'mutation', variables);
    },
    setShipmentStopStatusCompleted_mutation(variables: Types.SetShipmentStopStatusCompleted_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SetShipmentStopStatusCompleted_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SetShipmentStopStatusCompleted_Mutation>(SetShipmentStopStatusCompleted_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setShipmentStopStatusCompleted_mutation', 'mutation', variables);
    },
    signedBucketUrl_query(variables: Types.SignedBucketUrl_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SignedBucketUrl_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SignedBucketUrl_Query>(SignedBucketUrl_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'signedBucketUrl_query', 'query', variables);
    },
    unassignCarrier_mutation(variables: Types.UnassignCarrier_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UnassignCarrier_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UnassignCarrier_Mutation>(UnassignCarrier_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unassignCarrier_mutation', 'mutation', variables);
    },
    updateReferenceId_mutation(variables: Types.UpdateReferenceId_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateReferenceId_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateReferenceId_Mutation>(UpdateReferenceId_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateReferenceId_mutation', 'mutation', variables);
    },
    updateShipmentDriver_mutation(variables: Types.UpdateShipmentDriver_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateShipmentDriver_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateShipmentDriver_Mutation>(UpdateShipmentDriver_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateShipmentDriver_mutation', 'mutation', variables);
    },
    updateShipmentStopActualArrivalTime_mutation(variables: Types.UpdateShipmentStopActualArrivalTime_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateShipmentStopActualArrivalTime_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateShipmentStopActualArrivalTime_Mutation>(UpdateShipmentStopActualArrivalTime_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateShipmentStopActualArrivalTime_mutation', 'mutation', variables);
    },
    updateShipmentStopsEstimatedTimes_mutation(variables: Types.UpdateShipmentStopsEstimatedTimes_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateShipmentStopsEstimatedTimes_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateShipmentStopsEstimatedTimes_Mutation>(UpdateShipmentStopsEstimatedTimes_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateShipmentStopsEstimatedTimes_mutation', 'mutation', variables);
    },
    updateShipmentVehicle_mutation(variables: Types.UpdateShipmentVehicle_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateShipmentVehicle_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateShipmentVehicle_Mutation>(UpdateShipmentVehicle_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateShipmentVehicle_mutation', 'mutation', variables);
    },
    completeRegistration_mutation(variables: Types.CompleteRegistration_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CompleteRegistration_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CompleteRegistration_Mutation>(CompleteRegistration_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'completeRegistration_mutation', 'mutation', variables);
    },
    deleteInvitation_mutation(variables: Types.DeleteInvitation_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.DeleteInvitation_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteInvitation_Mutation>(DeleteInvitation_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteInvitation_mutation', 'mutation', variables);
    },
    getDecryptedPayload_query(variables: Types.GetDecryptedPayload_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.GetDecryptedPayload_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetDecryptedPayload_Query>(GetDecryptedPayload_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDecryptedPayload_query', 'query', variables);
    },
    getLogoUrl_query(variables: Types.GetLogoUrl_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.GetLogoUrl_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetLogoUrl_Query>(GetLogoUrl_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getLogoUrl_query', 'query', variables);
    },
    getMe_query(variables?: Types.GetMe_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.GetMe_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetMe_Query>(GetMe_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMe_query', 'query', variables);
    },
    getMyTenant_query(variables?: Types.GetMyTenant_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.GetMyTenant_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetMyTenant_Query>(GetMyTenant_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMyTenant_query', 'query', variables);
    },
    getMyTenantUsers_query(variables: Types.GetMyTenantUsers_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.GetMyTenantUsers_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetMyTenantUsers_Query>(GetMyTenantUsers_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMyTenantUsers_query', 'query', variables);
    },
    resendInvitation_mutation(variables: Types.ResendInvitation_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.ResendInvitation_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ResendInvitation_Mutation>(ResendInvitation_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'resendInvitation_mutation', 'mutation', variables);
    },
    resetPassword_mutation(variables: Types.ResetPassword_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.ResetPassword_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ResetPassword_Mutation>(ResetPassword_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'resetPassword_mutation', 'mutation', variables);
    },
    sendInvitation_mutation(variables: Types.SendInvitation_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SendInvitation_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SendInvitation_Mutation>(SendInvitation_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendInvitation_mutation', 'mutation', variables);
    },
    sendPasswordResetEmail_mutation(variables: Types.SendPasswordResetEmail_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SendPasswordResetEmail_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SendPasswordResetEmail_Mutation>(SendPasswordResetEmail_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendPasswordResetEmail_mutation', 'mutation', variables);
    },
    signedTenantBucketUrl_query(variables: Types.SignedTenantBucketUrl_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SignedTenantBucketUrl_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SignedTenantBucketUrl_Query>(SignedTenantBucketUrl_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'signedTenantBucketUrl_query', 'query', variables);
    },
    updateMe_mutation(variables: Types.UpdateMe_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateMe_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateMe_Mutation>(UpdateMe_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMe_mutation', 'mutation', variables);
    },
    updateMyTenant_mutation(variables: Types.UpdateMyTenant_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateMyTenant_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateMyTenant_Mutation>(UpdateMyTenant_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMyTenant_mutation', 'mutation', variables);
    },
    updateUserByAdmin_mutation(variables: Types.UpdateUserByAdmin_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateUserByAdmin_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateUserByAdmin_Mutation>(UpdateUserByAdmin_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserByAdmin_mutation', 'mutation', variables);
    },
    addFleetsToTourPlan_mutation(variables: Types.AddFleetsToTourPlan_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.AddFleetsToTourPlan_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AddFleetsToTourPlan_Mutation>(AddFleetsToTourPlan_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addFleetsToTourPlan_mutation', 'mutation', variables);
    },
    addLoadToFleet_mutation(variables: Types.AddLoadToFleet_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.AddLoadToFleet_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AddLoadToFleet_Mutation>(AddLoadToFleet_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addLoadToFleet_mutation', 'mutation', variables);
    },
    addLoadToTour_mutation(variables: Types.AddLoadToTour_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.AddLoadToTour_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AddLoadToTour_Mutation>(AddLoadToTour_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addLoadToTour_mutation', 'mutation', variables);
    },
    addLoadToVehicle_mutation(variables: Types.AddLoadToVehicle_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.AddLoadToVehicle_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AddLoadToVehicle_Mutation>(AddLoadToVehicle_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addLoadToVehicle_mutation', 'mutation', variables);
    },
    assignUnplannedLoads_mutation(variables: Types.AssignUnplannedLoads_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.AssignUnplannedLoads_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AssignUnplannedLoads_Mutation>(AssignUnplannedLoads_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'assignUnplannedLoads_mutation', 'mutation', variables);
    },
    assignUnplannedLoadsAsync_mutation(variables: Types.AssignUnplannedLoadsAsync_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.AssignUnplannedLoadsAsync_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AssignUnplannedLoadsAsync_Mutation>(AssignUnplannedLoadsAsync_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'assignUnplannedLoadsAsync_mutation', 'mutation', variables);
    },
    bulkLockTours_mutation(variables: Types.BulkLockTours_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.BulkLockTours_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.BulkLockTours_Mutation>(BulkLockTours_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkLockTours_mutation', 'mutation', variables);
    },
    cancelPlanning_mutation(variables: Types.CancelPlanning_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CancelPlanning_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CancelPlanning_Mutation>(CancelPlanning_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cancelPlanning_mutation', 'mutation', variables);
    },
    createTourPlan_mutation(variables: Types.CreateTourPlan_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.CreateTourPlan_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateTourPlan_Mutation>(CreateTourPlan_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTourPlan_mutation', 'mutation', variables);
    },
    findLoadsUsedInTourPlan_query(variables: Types.FindLoadsUsedInTourPlan_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FindLoadsUsedInTourPlan_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FindLoadsUsedInTourPlan_Query>(FindLoadsUsedInTourPlan_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findLoadsUsedInTourPlan_query', 'query', variables);
    },
    getTourPlannerConfiguration_query(variables?: Types.GetTourPlannerConfiguration_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.GetTourPlannerConfiguration_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetTourPlannerConfiguration_Query>(GetTourPlannerConfiguration_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTourPlannerConfiguration_query', 'query', variables);
    },
    lockTour_mutation(variables: Types.LockTour_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.LockTour_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.LockTour_Mutation>(LockTour_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lockTour_mutation', 'mutation', variables);
    },
    moveFleetsFromDateToTourPlan_mutation(variables: Types.MoveFleetsFromDateToTourPlan_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.MoveFleetsFromDateToTourPlan_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.MoveFleetsFromDateToTourPlan_Mutation>(MoveFleetsFromDateToTourPlan_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'moveFleetsFromDateToTourPlan_mutation', 'mutation', variables);
    },
    moveLoadToFleet_mutation(variables: Types.MoveLoadToFleet_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.MoveLoadToFleet_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.MoveLoadToFleet_Mutation>(MoveLoadToFleet_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'moveLoadToFleet_mutation', 'mutation', variables);
    },
    moveLoadToStop_mutation(variables: Types.MoveLoadToStop_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.MoveLoadToStop_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.MoveLoadToStop_Mutation>(MoveLoadToStop_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'moveLoadToStop_mutation', 'mutation', variables);
    },
    moveLoadToTour_mutation(variables: Types.MoveLoadToTour_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.MoveLoadToTour_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.MoveLoadToTour_Mutation>(MoveLoadToTour_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'moveLoadToTour_mutation', 'mutation', variables);
    },
    moveLoadToVehicle_mutation(variables: Types.MoveLoadToVehicle_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.MoveLoadToVehicle_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.MoveLoadToVehicle_Mutation>(MoveLoadToVehicle_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'moveLoadToVehicle_mutation', 'mutation', variables);
    },
    moveStopToFleet_mutation(variables: Types.MoveStopToFleet_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.MoveStopToFleet_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.MoveStopToFleet_Mutation>(MoveStopToFleet_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'moveStopToFleet_mutation', 'mutation', variables);
    },
    moveStopToTour_mutation(variables: Types.MoveStopToTour_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.MoveStopToTour_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.MoveStopToTour_Mutation>(MoveStopToTour_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'moveStopToTour_mutation', 'mutation', variables);
    },
    moveTourToFleet_mutation(variables: Types.MoveTourToFleet_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.MoveTourToFleet_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.MoveTourToFleet_Mutation>(MoveTourToFleet_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'moveTourToFleet_mutation', 'mutation', variables);
    },
    optimizeFleet_mutation(variables: Types.OptimizeFleet_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.OptimizeFleet_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.OptimizeFleet_Mutation>(OptimizeFleet_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'optimizeFleet_mutation', 'mutation', variables);
    },
    removeFleetsFromTourPlan_mutation(variables: Types.RemoveFleetsFromTourPlan_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.RemoveFleetsFromTourPlan_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RemoveFleetsFromTourPlan_Mutation>(RemoveFleetsFromTourPlan_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeFleetsFromTourPlan_mutation', 'mutation', variables);
    },
    removeLoadFromTourPlan_mutation(variables: Types.RemoveLoadFromTourPlan_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.RemoveLoadFromTourPlan_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RemoveLoadFromTourPlan_Mutation>(RemoveLoadFromTourPlan_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeLoadFromTourPlan_mutation', 'mutation', variables);
    },
    removeStopFromTourPlan_mutation(variables: Types.RemoveStopFromTourPlan_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.RemoveStopFromTourPlan_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RemoveStopFromTourPlan_Mutation>(RemoveStopFromTourPlan_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeStopFromTourPlan_mutation', 'mutation', variables);
    },
    removeTourFromTourPlan_mutation(variables: Types.RemoveTourFromTourPlan_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.RemoveTourFromTourPlan_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RemoveTourFromTourPlan_Mutation>(RemoveTourFromTourPlan_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeTourFromTourPlan_mutation', 'mutation', variables);
    },
    reverseTour_mutation(variables: Types.ReverseTour_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.ReverseTour_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ReverseTour_Mutation>(ReverseTour_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reverseTour_mutation', 'mutation', variables);
    },
    sendTourToShipmentExecution_mutation(variables: Types.SendTourToShipmentExecution_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SendTourToShipmentExecution_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SendTourToShipmentExecution_Mutation>(SendTourToShipmentExecution_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendTourToShipmentExecution_mutation', 'mutation', variables);
    },
    tourPlanById_query(variables: Types.TourPlanById_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.TourPlanById_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.TourPlanById_Query>(TourPlanById_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tourPlanById_query', 'query', variables);
    },
    tourPlanByName_query(variables: Types.TourPlanByName_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.TourPlanByName_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.TourPlanByName_Query>(TourPlanByName_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tourPlanByName_query', 'query', variables);
    },
    tourPlanScore_query(variables: Types.TourPlanScore_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.TourPlanScore_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.TourPlanScore_Query>(TourPlanScore_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tourPlanScore_query', 'query', variables);
    },
    tourPlansByDate_query(variables: Types.TourPlansByDate_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.TourPlansByDate_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.TourPlansByDate_Query>(TourPlansByDate_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tourPlansByDate_query', 'query', variables);
    },
    tourPlansByDateAggregated_query(variables: Types.TourPlansByDateAggregated_QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.TourPlansByDateAggregated_Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.TourPlansByDateAggregated_Query>(TourPlansByDateAggregated_QueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tourPlansByDateAggregated_query', 'query', variables);
    },
    unlockTour_mutation(variables: Types.UnlockTour_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UnlockTour_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UnlockTour_Mutation>(UnlockTour_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unlockTour_mutation', 'mutation', variables);
    },
    updateTourPlannerConfiguration_mutation(variables: Types.UpdateTourPlannerConfiguration_MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateTourPlannerConfiguration_Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateTourPlannerConfiguration_Mutation>(UpdateTourPlannerConfiguration_MutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTourPlannerConfiguration_mutation', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;